{
  "navigation": {
    "home": "Home",
    "inventory": "Inventory",
    "recipes": "Recipes",
    "profile": "Profile",
    "back": "Back",
    "myMeals": "My Meals",
    "grocery": "Grocery",
    "pantry": "Pantry",
    "settings": "Settings"
  },
  "auth": {
    "errGeneric": "Sign-in didn't go through. Please try again.",
    "login": "Sign In",
    "register": "Sign Up",
    "logout": "Sign Out",
    "signIn": "Sign In",
    "guestMode": "Guest Mode",
    "signInToSync": "Sign in to sync your data",
    "logoutConfirmation": "Are you sure you want to sign out?",
    "email": "Email",
    "password": "Password",
    "loginButton": "Sign In",
    "registerButton": "Create Account",
    "switchToRegister": "Don't have an account? Sign up",
    "switchToLogin": "Already have an account? Sign in",
    "tagline": "Your AI-powered meal planning assistant",
    "signInWithEmail": "Sign in with Email",
    "backToOptions": "Back to options",
    "continueWithGoogle": "Continue with Google",
    "or": "or",
    "continueAsGuest": "Continue as Guest",
    "localStorageOnly": "Data stored locally only",
    "dataAgreement": "By continuing, you agree to let Du Chef store your food data to provide personalized recommendations.",
    "signUpToConfirm": "Sign up to confirm your plan",
    "validationEmailRequired": "Please enter your email address.",
    "validationEmailInvalid": "Please enter a valid email address.",
    "validationPasswordRequired": "Please enter your password.",
    "validationPasswordLength": "Password must be at least 6 characters.",
    "continueTitle": "Let's keep going.",
    "emailLabel": "Email address",
    "continue": "Continue",
    "welcomeBack": "Welcome back",
    "forgotPassword": "Forgot password?",
    "createTitle": "Let's create your account.",
    "choosePassword": "Choose a password",
    "createMyAccount": "Create my account",
    "legalFine": "By continuing, you agree to our terms and privacy policy.",
    "change": "Change",
    "successTitle": "You're all set!",
    "successSub": "Your synced kitchen is waiting.",
    "openPaprika": "Open Du Chef",
    "brandHeadline": "One account, everything follows.",
    "reason1": "Your recipes on all your devices",
    "reason2": "Save the ones you love",
    "reason3": "Scan your fridge and pantry with a photo",
    "madeIn": "Homemade · in Montréal",
    "guestLink": "Continue without an account",
    "errGoogleCancelledTitle": "Google sign-in interrupted",
    "errGoogleCancelledMsg": "The window closed before finishing. Pick it back up whenever — nothing was lost.",
    "retryGoogle": "Retry with Google",
    "errEmailFormat": "This address doesn't look valid — check the ending (.com, .ca…).",
    "errBadPassword": "Incorrect password. Try again.",
    "resetMyPassword": "Reset my password",
    "errLockedTitle": "Too many attempts",
    "errLockedMsg": "For your security, sign-in is paused for a few minutes. Reset your password to get in right away.",
    "resetNow": "Reset now",
    "errOfflineTitle": "Can't connect",
    "errOfflineMsg": "Couldn't reach Du Chef. Check your internet connection.",
    "retry": "Retry",
    "resetSentTitle": "Email sent",
    "resetSentMsg": "If an account exists for this address, a reset link was just sent.",
    "wrongCredentials": "Incorrect email or password. Please try again.",
    "emailExists": "An account with this email already exists. Sign in instead.",
    "tooManyAttempts": "Too many failed attempts. Please wait a moment and try again.",
    "networkError": "Network error. Please check your connection.",
    "resetLink": {
      "checking": "Checking your link…",
      "title": "A new password",
      "newPassword": "New password",
      "save": "Save and sign me in",
      "invalidTitle": "This link no longer works",
      "invalidMsg": "A reset link works for one hour, and only once. Ask for a new one and I'll send it right away.",
      "newLink": "Get a new link",
      "failed": "I couldn't save this password. Try again.",
      "savedSignIn": "Your new password is saved. Sign in with it.",
      "signIn": "Sign me in"
    }
  },
  "profile": {
    "accountInformation": "Account Information",
    "languageSettings": "Language Settings",
    "editProfile": "Edit Profile",
    "editProfileDescription": "Profile editing coming soon"
  },
  "home": {
    "title": "Du Chef",
    "welcome": "Welcome to Du Chef!",
    "addFoodItem": "Add Food Item",
    "scanFood": "Scan food with your camera",
    "viewInventory": "View Inventory",
    "getRecipes": "Get Recipe Suggestions",
    "myInventory": "My Inventory",
    "recipeSuggestions": "Recipe Suggestions",
    "findRecipes": "Find recipes with your ingredients",
    "quickActions": "Quick Actions",
    "settings": "Settings",
    "appPreferences": "App preferences and profile",
    "yourInventory": "Your Inventory",
    "itemsInKitchen": "{{count}} item in your kitchen",
    "itemsInKitchen_other": "{{count}} items in your kitchen",
    "itemsExpiringSoon": "{{count}} item expiring soon",
    "itemsExpiringSoon_other": "{{count}} items expiring soon",
    "getStarted": "Get Started",
    "getStartedText": "Start building your food inventory to get personalized recipe suggestions and reduce food waste",
    "startHere": "Start here! Build your first inventory",
    "thisWeek": "This Week",
    "mealsPlanned": "{{count}} meal planned",
    "mealsPlanned_other": "{{count}} meals planned",
    "planYourWeek": "Plan your week"
  },
  "inventory": {
    "title": "My Inventory",
    "foodInventory": "Food Inventory",
    "addItem": "Add Item",
    "scanFood": "Scan Food",
    "addManually": "Add Manually",
    "editItem": "Edit Item",
    "deleteItem": "Delete Item",
    "expiringSoon": "Expiring Soon",
    "expired": "Expired",
    "fresh": "Fresh",
    "quantity": "Quantity",
    "expiryDate": "Expiry Date",
    "location": "Location",
    "notes": "Notes",
    "save": "Save",
    "cancel": "Cancel",
    "camera": "Camera",
    "gallery": "Gallery",
    "noItems": "No items in your inventory",
    "addFirstItem": "Add your first item to get started",
    "loading": "Loading inventory...",
    "loadingRecognition": "Analyzing image...",
    "recognitionResults": "Recognition Results",
    "itemsFound": "items found",
    "addSelected": "Add Selected Items",
    "addAll": "Add All",
    "clearAll": "Clear All",
    "totalItems": "Total Items",
    "categories": "Categories",
    "lastUpdated": "Last updated",
    "lastSynced": "Last synced",
    "selectMultiple": "Select Multiple",
    "itemsExpiringSoonFilter": "{{count}} item expiring soon! (tap to filter)",
    "itemsExpiringSoonFilter_other": "{{count}} items expiring soon! (tap to filter)",
    "expiring": "expiring",
    "qty": "Qty",
    "daysLeft": "{{count}}d left",
    "daysAgo": "{{count}}d ago",
    "days": "{{count}}d",
    "noExpiry": "No expiry",
    "edit": "Edit",
    "eaten": "Eaten",
    "markAsEaten": "Mark as Eaten",
    "markAsEatenConfirm": "Mark \"{{name}}\" as eaten? This will remove it from your active inventory.",
    "expiredDaysAgo": "Expired {{count}} day ago",
    "expiredDaysAgo_other": "Expired {{count}} days ago",
    "expiresToday": "Expires today",
    "expiresTomorrow": "Expires tomorrow",
    "expiresInDays": "Expires in {{count}} day",
    "expiresInDays_other": "Expires in {{count}} days",
    "sync": "Sync",
    "home": "Home",
    "fridgePhoto": "Fridge Photo",
    "receipt": "Receipt",
    "receiptScan": "Receipt Scan",
    "foodScanner": "Food Scanner",
    "receiptScanner": "Receipt Scanner",
    "foodScannerDescription": "Take a photo of your fridge, pantry, or ingredients to automatically identify and track them.",
    "receiptScannerDescription": "Take a photo of your grocery store receipt to automatically add purchased items to your inventory.",
    "selectImage": "Select Image",
    "openCamera": "Open Camera",
    "retake": "Retake",
    "analyzeFood": "Analyze Food",
    "scanReceipt": "Scan Receipt",
    "processing": "Processing...",
    "analyzingFoodItems": "Analyzing food items...",
    "devMode": "DEV MODE",
    "usingTestImage": "Using test image",
    "categoryFruits": "Fruits",
    "categoryVegetables": "Vegetables",
    "categoryDairy": "Dairy",
    "categoryMeat": "Meat",
    "categoryBeverages": "Beverages",
    "categoryCondiments": "Condiments",
    "categorySpices": "Spices",
    "categoryLeftovers": "Leftovers",
    "categoryPackagedFoods": "Packaged Foods",
    "categoryBreadGrains": "Bread/Grains",
    "categoryPlantBasedProtein": "Plant-Based Protein",
    "categoryOther": "Other",
    "itemNameLabel": "Item Name",
    "itemNamePlaceholder": "e.g., Milk, Bananas, Leftover Pasta...",
    "optional": "Optional",
    "expiryHint": "Leave empty if you don't know the expiry date",
    "dayLabel": "Day",
    "monthLabel": "Month",
    "yearLabel": "Year",
    "expiryNoteLabel": "Expiry Note",
    "expiryNotePlaceholder": "e.g., Best before date, Use by date...",
    "editLaterHint": "You can always edit these details later by tapping on the item in your inventory.",
    "addToInventory": "Add to Inventory",
    "errorInvalidName": "Please enter an item name",
    "errorInvalidDay": "Please enter a valid day (1-31)",
    "errorInvalidMonth": "Please enter a valid month (1-12)",
    "errorInvalidYear": "Please enter a valid year (2024-2030)",
    "errorInvalidDate": "Please enter a valid date",
    "manualExpiryExplanation": "Manually entered expiry date",
    "categoryLabel": "Category",
    "scanCarousel1": "Identifying every ingredient in your fridge...",
    "scanCarousel2": "Tracking expiry dates so nothing goes to waste.",
    "scanCarousel3": "Building your digital pantry for smarter shopping.",
    "scanCarousel4": "Matching what you have to personalized recipes.",
    "scanCarousel5": "Planning meals around your real ingredients.",
    "scanCarousel6": "Helping you save money by using what you already own.",
    "scanCarousel7": "One photo. A week of meals. Zero food waste.",
    "confirmDateTitle": "Confirm purchase date",
    "confirmDateMessage": "We couldn't read the date on this receipt. Please confirm when you shopped before saving.",
    "failedToAnalyze": "Failed to analyze image",
    "quotaExceeded": "You've used today's scanning allowance. It resets tomorrow — you can still add items by hand in the meantime.",
    "confirmDatePrompt": "We couldn't read the receipt date. When did you shop?",
    "today": "Today",
    "yesterday": "Yesterday",
    "invalidDateTitle": "Invalid date",
    "invalidDateMessage": "Please enter a valid date (YYYY-MM-DD) that is not in the future.",
    "dateConfirmed": "Date confirmed",
    "confirmDateButton": "Confirm date",
    "detectedItem": "DETECTED ITEM",
    "match": "MATCH",
    "ignore": "IGNORE",
    "confirm": "CONFIRM",
    "confirmItems": "Confirm items",
    "tapMarkers": "Tap markers to review items",
    "placingMarkers": "Placing markers on detected items…",
    "howMuch": "How much do you have?",
    "takePictureFailed": "Failed to take picture. Please try again.",
    "parseFailed": "Failed to parse recognition results",
    "incompleteScanWarning": "We couldn't read {{failed}} of {{total}} sections of this receipt — some items may be missing. Add them by hand after saving."
  },
  "recipes": {
    "title": "Recipes",
    "searchPlaceholder": "Search recipes...",
    "omnibar": {
      "placeholder": "Search or ask Du Chef",
      "placeholderFocused": "Search…"
    },
    "shelves": {
      "recentlyAdded": "Recently added",
      "recentlyViewed": "Recently viewed",
      "topRated": "Your highest rated",
      "communityTop": "Top from other cooks",
      "pantry": "Your pantry",
      "seeAll": "See all",
      "pantryCount": "{{count}} available"
    },
    "ideaOfDay": {
      "title": "Today's idea",
      "angles": {
        "fast": "Quickest",
        "fridge": "Uses your fridge",
        "new": "Never tried",
        "fav": "Sure thing"
      }
    },
    "filters": {
      "button": "Filters",
      "title": "Filters",
      "reset": "Reset",
      "apply": "See {{count}} recipes",
      "diet": {
        "label": "Diet",
        "all": "All",
        "veg": "Veg",
        "fish": "Fish",
        "meat": "Meat"
      },
      "duration": {
        "15": "< 15 min",
        "30": "< 30 min",
        "45": "< 45 min",
        "60": "< 1 h",
        "label": "Duration",
        "all": "All"
      },
      "rating": {
        "label": "Rating",
        "all": "All",
        "4.5": "★ 4.5+",
        "4.8": "★ 4.8+",
        "5.0": "★ 5 only"
      },
      "mealType": {
        "label": "Meal type",
        "breakfast": "Breakfast",
        "lunch": "Lunch",
        "dinner": "Dinner",
        "dessert": "Dessert"
      },
      "preference": {
        "diet": "{{diet}} · your preference"
      }
    },
    "search": {
      "cancel": "Cancel",
      "resultsCount": "{{count}} recipe · \"{{query}}\"",
      "resultsCount_other": "{{count}} recipes · \"{{query}}\"",
      "rows": {
        "yours": "Your recipes",
        "rest": "Other recipes",
        "backToAll": "All results",
        "addedOn": "Added {{date}}"
      }
    },
    "aiEscalation": {
      "title": "Ask Du Chef",
      "suggestion": "What can I make with {{query}} tonight?"
    },
    "noRecipes": "No recipes found",
    "loadingSuggestions": "Finding recipes for you...",
    "findingPerfectRecipes": "Finding perfect recipes for you based on your inventory...",
    "searchingTrustedSources": "Searching trusted sources:",
    "basedOnInventory": "Based on your {{count}} inventory item",
    "basedOnInventory_other": "Based on your {{count}} inventory items",
    "customizeRecipeSearch": "Customize Recipe Search",
    "selectedExpiring": "{{selected}} selected • {{expiring}} expiring",
    "searchInventory": "Search inventory...",
    "selectAll": "Select All",
    "clearAll": "Clear All",
    "selectedCount": "Selected ({{count}}):",
    "proteins": "PROTEINS",
    "vegetables": "VEGETABLES",
    "otherIngredients": "OTHER INGREDIENTS",
    "noIngredientsFound": "No ingredients found",
    "tryDifferentSearch": "Try a different search term",
    "minimumSelectionRequired": "Minimum Selection Required",
    "minimumSelectionMessage": "Please select at least 2 ingredients to search for recipes.",
    "expShort": "Exp.",
    "cancel": "Cancel",
    "applyCount": "Apply ({{count}})",
    "expInvalidDate": "Exp. Invalid Date",
    "matchScore": "Match Score",
    "servings": "servings",
    "readyIn": "Ready in",
    "healthScore": "Health Score",
    "ingredients": "Ingredients",
    "instructions": "Instructions",
    "missing": "Missing",
    "expiringSoon": "Uses {{count}} expiring item",
    "expiringSoon_other": "Uses {{count}} expiring items",
    "originalLanguage": "Original Language",
    "translateTo": "Translate to {{language}}",
    "translating": "Translating...",
    "translatedFrom": "Translated from {{language}}",
    "personalRecipe": "Personal Recipe",
    "recipeNotFound": "Recipe not found",
    "loadingRecipe": "Loading recipe...",
    "goHome": "Go Home",
    "home": "Home",
    "tabs": {
      "browse": "Browse",
      "askAI": "Ask Du Chef"
    },
    "aiPlaceholder": "Search recipes or paste a full recipe to add it...",
    "aiSearching": "Searching...",
    "aiNoResults": "No matching recipes found. Try rephrasing your query.",
    "aiError": "Something went wrong. Please try again.",
    "aiSignInRequired": "Sign in to use Ask Du Chef.",
    "chatEmptyHeadline": "What are you in the mood for?",
    "chatEmptySubtext": "Search your recipes, or paste one to add it to your collection.",
    "chatInputPlaceholder": "Ask about any recipe…",
    "addFirstRecipe": "Add your first recipe to get started",
    "importDescription": "Import from a website or add manually",
    "addRecipe": "Add Recipe",
    "loadingRecipes": "Loading recipes...",
    "trySearching": "Try a different search or filter",
    "filteredCount": "{{filtered}} of {{total}}",
    "shortcuts": {
      "quick": "≤ 20 min",
      "quick30": "≤ 30 min",
      "quick45": "≤ 45 min",
      "pantry": "My fridge",
      "topRated": "4.5+",
      "surprise": "Surprise me",
      "surpriseShort": "Surprise",
      "vegetarian": "Vegetarian",
      "fish": "Fish",
      "without": "No {{word}}"
    },
    "libraryCount_one": "{{count}} recipe",
    "libraryCount_other": "{{count}} recipes",
    "cookingFor": "Cooking for {{count}}",
    "cookTime": "cook time",
    "ask": "Ask",
    "cook": "Cook",
    "signInToSave": "Please sign in to save recipes",
    "recipeDetected": "Recipe detected! Review below.",
    "saveRecipe": "Save Recipe",
    "ingredientsCount": "{{count}} ingredients",
    "stepsCount": "{{count}} steps",
    "parsingRecipe": "Analyzing recipe text...",
    "incompleteRecipeError": "This recipe is missing ingredients or steps — add them before saving",
    "mealTypes": {
      "recent": "Recent",
      "all": "All",
      "myTopRated": "My Top Rated",
      "topOnline": "Top Online",
      "breakfast": "Breakfast",
      "mainCourse": "Main Course",
      "dessert": "Dessert",
      "snack": "Snack",
      "appetizer": "Appetizer",
      "sideDish": "Side Dish",
      "salad": "Salad",
      "soup": "Soup",
      "beverage": "Beverage"
    },
    "myTopRatedBanner": "These ratings are yours — not from the recipe website. Rate any recipe to build your list.",
    "myTopRatedEmpty": "Rate recipes to see them here",
    "myTopRatedExplore": "Explore recipes",
    "libraryCount": "{{count}} recipe",
    "nearMissBanner": "No exact match — here is the closest",
    "nearMissEyebrow": "SIMILAR",
    "resultsCount_one": "{{count}} RECIPE",
    "resultsCount_other": "{{count}} RECIPES",
    "exactSearchEyebrow": "EXACT SEARCH",
    "noResultsAtAll": "No recipe matches that search",
    "activeFilters": "ACTIVE FILTERS",
    "understoodLine": "Du Chef understood — remove a token or refine above",
    "exactSearchLink": "Exact search",
    "searchIdleHint": "Search by recipe, ingredient or cuisine — or ask Du Chef a question.",
    "stepsCount_one": "{{count}} step"
  },
  "fanReasons": {
    "fastSaves": "{{count}} min less than now",
    "fastSaves_other": "{{count}} min less than now",
    "fastOnly": "Only {{count}} min",
    "fastOnly_other": "Only {{count}} min",
    "fastGeneric": "A fast classic",
    "fridgeHits": "{{count}} ingredient already at home",
    "fridgeHits_other": "{{count}} ingredients already at home",
    "fridgeGeneric": "A change from the usual",
    "balance": "Balances the week",
    "new": "Not in your history",
    "favRating": "{{rating}} ★",
    "favGeneric": "Your best match",
    "fast": "Faster",
    "fastMore": "Even faster",
    "fridge": "Uses your fridge",
    "fav": "Sure thing",
    "balanceLabel": "Balances the week",
    "newLabel": "Never tried",
    "balanceFish": "Rebalances: +1 fish this week",
    "balanceVeg": "Rebalances: +1 vegetarian this week",
    "balanceMeat": "Rebalances: +1 meat this week"
  },
  "fanChips": {
    "more_one": "{{count}} new",
    "more_other": "{{count}} new",
    "moreLabel_one": "Suggest {{count}} new idea",
    "moreLabel_other": "Suggest {{count}} new ideas",
    "restart": "Start over",
    "sweet": "Sweet",
    "savory": "Savory",
    "soup": "Soup",
    "salad": "Salad",
    "sandwich": "Sandwich",
    "pasta": "Pasta",
    "fish": "Fish",
    "veg": "Veggie",
    "quick": "Quick",
    "fridge": "My fridge",
    "favorites": "My favorites",
    "loved": "You loved it"
  },
  "sideFoods": {
    "label": "With what you have",
    "rows": "×{{count}}",
    "with": "With {{foods}}",
    "withAlso": "With {{foods}} · also {{also}}",
    "noneTogether": "I have no side with {{foods}} together. Here are the ones that use some of them."
  },
  "sideReasons": {
    "togetherLabel": "Ready together",
    "fridgeFoods": "Uses your {{foods}}",
    "together": "{{count}} min, while the main cooks",
    "together_other": "{{count}} min, while the main cooks",
    "balanceLabel": "Rounds out the plate",
    "fresh": "Something fresh on the side",
    "vegetable": "A vegetable on the side",
    "starch": "Something filling on the side"
  },
  "recipeSuggestions": {
    "searchSummary": {
      "title": "Search Insights",
      "expiring": "expiring",
      "ingredientsLabel": "Ingredients Selected",
      "sourcesLabel": "Sources Searched",
      "queriesCount": "{{count}} search query generated",
      "queriesCount_other": "{{count}} search queries generated",
      "tapHint": "Tap to select/deselect",
      "tapHintSources": "Tap to include/exclude",
      "searchWithIngredients": "Search ({{count}} ingredient)",
      "searchWithIngredients_other": "Search ({{count}} ingredients)",
      "expiringCount": "{{count}} expiring"
    },
    "title": "Recipe suggestions",
    "moved": "This feature is moving to the weekly meal planner."
  },
  "thisWeek": {
    "title": "This Week",
    "yourWeek": "Your Week",
    "noMealsPlanned": "No Meals Planned Yet",
    "startPlanning": "Start planning your week by tapping the calendar icon on recipe cards",
    "browseRecipes": "Browse Recipes",
    "addMoreMeals": "Add More Meals",
    "fridgeStocked": "Your fridge is stocked!",
    "itemsAddedSuffix": "items added to your pantry. Generate meals based on what you have.",
    "generateFromInventory": "Generate meals based on what you have.",
    "generateMeals": "Generate Meals for This Week",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "yesterday": "Yesterday",
    "recipeNotAvailable": "Recipe Not Available",
    "recipeNotAvailableText": "Recipe details are not available for this meal.",
    "unknownRecipe": "Unknown Recipe",
    "swappingRecipe": "Swapping recipe...",
    "shoppingNeeded": "Shopping needed",
    "readyToCook": "Ready to cook",
    "reviewIngredients": "Review ingredients",
    "mealTypes": {
      "breakfast": "Breakfast",
      "lunch": "Lunch",
      "dinner": "Dinner"
    },
    "dayNames": {
      "sunday": "Sunday",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday"
    },
    "dayShort": {
      "sun": "Sun",
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat"
    },
    "noMealsPlannedShort": "No meals planned",
    "weekOf": "Week of {{range}}",
    "previousWeek": "Previous week",
    "nextWeek": "Next week",
    "addMealType": "ADD {{mealType}}",
    "add": "Add",
    "openRow": "Show {{meal}} larger",
    "weeklyMenu": "This Week's Menu",
    "tasteProfile": "Your Taste Profile",
    "seasons": {
      "winter": "Winter",
      "spring": "Spring",
      "summer": "Summer",
      "fall": "Fall"
    },
    "progress": {
      "cooked": "{{cooked}} of {{total}} cooked",
      "skipped": "{{skipped}} skipped",
      "toCome": "{{upcoming}} to come"
    },
    "mealTags": {
      "meat": "Meat",
      "fish": "Fish",
      "veggie": "Veggie",
      "plantBased": "Plant Based",
      "notCooked": "Not Cooked"
    },
    "stats": {
      "meals": "{{count}} meals",
      "fish": "{{count}} fish",
      "veggie": "{{count}} veggie"
    },
    "heroTitle": "Your week, your dinners",
    "heroSubtitle": "We'll suggest dinners from your recipe collection. Snap your fridge to personalize the plan.",
    "generateMyWeek": "Generate My Week",
    "creatingYourPlan": "Creating your plan...",
    "planningYourWeek": "Planning your perfect week",
    "orAddManually": "or add meals manually",
    "startFresh": "Start fresh",
    "regenerateThisWeek": "Re-generate This Week",
    "clearPlanTitle": "Clear Plan",
    "clearPlanMessage": "Are you sure you want to clear all planned meals for this week?",
    "clearPlanConfirm": "Clear",
    "chooseARecipe": "Choose a Recipe",
    "addSlots": "Add {{count}} slots",
    "noMealsForDay": "No meals planned for this day",
    "dinnerAt": "Dinner at",
    "markAsDone": "Mark as done",
    "undo": "Undo",
    "rateThis": "Rate this",
    "enjoyed": "Enjoyed!",
    "timingNotAvailable": "Timing not available",
    "minTotal": "{{count}} min total",
    "prepAndCook": "({{prep}} prep + {{cook}} cook)",
    "untitledMeal": "Untitled meal",
    "showFullWeek": "Show full week",
    "compactView": "Compact view",
    "moveMealTitle": "Move meal",
    "selectDay": "Day",
    "selectMealType": "Meal",
    "slotFull": "full",
    "suggestAction": "Suggest",
    "moveAction": "Move",
    "deleteAction": "Delete",
    "idleTitle": "Let's plan your week",
    "idleBody": "Dinners for 7 nights · breakfasts on weekends. Optimized for your pantry.",
    "desktopIdleBody": "Du Chef selects 7 dinners based on your fridge, your tastes and the week's balance.",
    "idleFootnote": "You can adjust each meal after generation.",
    "idleFootnoteMobile": "You can change everything after.",
    "analyzingTaste": "Analyzing your tastes…",
    "weekView": "Week",
    "detailView": "Detail",
    "regenerate": "Re-generate",
    "regeneratePastOnly": "Those days are over, so I left them alone",
    "regenerateTodayKept": "I'm keeping today's meal. Open it to change it.",
    "regenerateRange": "Re-generates {{from}} → {{to}}",
    "regenerateRangeShort": "{{from}} → {{to}}",
    "noRecipeForMeal": "No {{meal}} recipe",
    "toastReplaced": "Replaced: {{title}}",
    "toastReplacedBy": "Replaced by « {{title}} »",
    "toastAdded": "Added: {{title}}",
    "toastAddedSimple": "« {{title}} » added",
    "toastMoved": "{{title}} moved",
    "toastSwapped": "{{title}} moved · swapped with {{other}}",
    "toastRemoved": "{{title}} removed",
    "meal": "Meal",
    "fanSheetTitle": "5 ideas for this meal",
    "currentMealPrefix": "currently",
    "viewRecipe": "View Recipe",
    "moveToDay": "Move to a day",
    "remove": "Remove",
    "orReplaceWith": "Or replace with",
    "noAlternatives": "No alternatives for this meal.",
    "browseLibrary": "Browse the full library",
    "moveTo": "Move to…",
    "fromDay": "from {{day}}",
    "emptySlot": "Empty",
    "noTimeLimit": "No limit",
    "swap": "Swap",
    "place": "Place",
    "regenerateWeek": "Re-generate the week",
    "dayProfiles": {
      "0": {
        "tag": "Without the kids",
        "note": "room for flavors they don't like"
      },
      "1": {
        "tag": "Without the kids",
        "note": "spices and new things welcome"
      },
      "2": {
        "tag": "Kids night",
        "note": "quick, simple, kid-approved"
      },
      "3": {
        "tag": "Weeknight",
        "note": "light and under 30 min"
      },
      "4": {
        "tag": "You have time",
        "note": "we can aim more ambitious tonight"
      },
      "5": {
        "tag": "Weekend",
        "note": "feel-good dish, real cooking"
      },
      "6": {
        "tag": "Batch cooking",
        "note": "perfect for cooking ahead"
      }
    },
    "desktopHint": "Click a recipe to open it · drag it to another day",
    "desktopHintTouch": "Tap a recipe to view it · tap \"Move\" to send it to another day",
    "editSettings": "Edit my settings",
    "library": "Library",
    "thisMeal": "This meal",
    "movedTo": "{{recipe}} moved to {{day}}",
    "swappedWith": "{{recipe}} ↔ {{day}} · swapped",
    "leftoverFrom": "From {{day}} ({{meal}})",
    "move": "Move",
    "dayWithDate": "{{day}} {{date}}",
    "addHere": "Add",
    "replace": "Replace",
    "replacedOn": "{{recipe}} replaced {{other}} · {{day}}",
    "stackedInto": "{{recipe}} added to {{day}}",
    "summary": {
      "recipes_one": "recipe",
      "recipes_other": "recipes",
      "dining_one": "eating out",
      "dining_other": "eating out",
      "notes_one": "simple meal",
      "notes_other": "simple meals",
      "skipped_one": "no meal",
      "skipped_other": "no meal"
    },
    "addDish": "Add a dish",
    "addDishTitle": "Add a dish to this meal",
    "orAddDish": "Or add a dish",
    "addSide": "a side",
    "addSideLong": "Add a side",
    "goesWith": "To go with it",
    "addToThisMeal": "Add to this meal",
    "withSide": "with",
    "moreSides": "More",
    "moreSidesLong": "More sides",
    "sidesOther": "Something else: bread, dessert, a second dish…",
    "sidesEmpty": "Nothing to suggest beside this dish. Search your recipes.",
    "removeSide": "Remove {{title}}",
    "dishCount_one": "{{count}} dish",
    "dishCount_other": "{{count}} dishes",
    "cooked": "Cooked",
    "cookNow": "Cook this",
    "cookedCount": "{{cooked}}/{{total}} cooked",
    "minutesShort": "{{count}} min",
    "servingsShort_one": "{{count}} serving",
    "servingsShort_other": "{{count}} servings",
    "viewFullRecipe": "View full recipe",
    "rateThisRecipe": "Rate this recipe",
    "unmarkCooked": "Remove \"cooked\"",
    "totalLabel": "Total",
    "portionsLabel": "Servings",
    "noRecipeThatDay": "Without a recipe",
    "picker": {
      "context": "{{meal}} · {{weekday}} {{date}}",
      "placeOn": "Put on {{day}}",
      "withIngredients": "With your ingredients",
      "results": "Results",
      "recipeCount_one": "{{count}} recipe",
      "recipeCount_other": "{{count}} recipes"
    },
    "wholeLibrary": "Whole library",
    "resetToWeekDefault": "Back to the week default ({{count}})",
    "noRecipeShort": "No recipe?",
    "clearSlot": "Clear slot",
    "planAMeal": "Plan a meal",
    "selectTimeSlot": "Select a time slot",
    "browseAllRecipes": "Browse all recipes",
    "addCustomMeal": "Add custom meal",
    "showAllSuggestions": "Show all suggestions",
    "orTypeYourOwn": "or type your own",
    "allIngredientsCovered": "All ingredients covered",
    "youHaveEverything": "You have everything!",
    "whyThisRecipe": "Why this recipe",
    "notCooked": "Not cooked",
    "noAlternativesFound": "No alternatives found",
    "noRecipesForFilter": "No recipes for this filter.",
    "dropHere": "Drop here",
    "noRecipesAvailable": "No recipes available. Please import some recipes first.",
    "generateFailed": "Failed to generate meal plan. Please try again.",
    "noAlternativeTryBrowse": "No alternative recipe found — try Browse all",
    "noNewIdea": "Could not find a new idea. Please try again.",
    "slotFullMax": "This meal slot is full (max {{max}})",
    "quickRestaurant": "Restaurant",
    "quickLeftovers": "Leftovers",
    "quickTakeout": "Takeout",
    "quickSkip": "Skip",
    "customMealPlaceholder": "e.g. \"Pasta night\", \"BBQ at Mike's\"",
    "leftoverFromFreezer": "From the freezer",
    "leftoverReheat": "Reheat",
    "leftoverThaw": "Take out the night before",
    "leftoverNoneTitle": "Nothing cooked recently",
    "leftoverNoneBody": "Leftovers show up here once you mark a meal as cooked.",
    "leftoverFridgeSection": "In the fridge · {{days}} days",
    "leftoverFreezerSection": "In the freezer",
    "leftoverPortionsLeft_one": "{{count}} portion",
    "leftoverPortionsLeft_other": "{{count}} portions",
    "leftoverExhausted": "all gone",
    "leftoverExpiresOn": "Expires {{date}}",
    "leftoverFrozenOn": "Frozen {{date}}",
    "leftoverPickerSubtitle": "{{day}} · from a recent meal",
    "leftoverBannerTitle_one": "{{count}} portion of leftovers to place",
    "leftoverBannerTitle_other": "{{count}} portions of leftovers to place",
    "leftoverBannerSub": "{{recipe}} · eat before {{date}}",
    "leftoverSlotHint": "Leftovers — {{recipe}}",
    "leftoverSlotHintSub_one": "{{count}} available · tap to place",
    "leftoverSlotHintSub_other": "{{count}} available · tap to place",
    "leftoverAskTitle": "Any {{recipe}} left over?",
    "leftoverAskSub": "Cooked {{day}} · {{servings}} portions planned",
    "leftoverAskFridge": "In the fridge",
    "leftoverAskFridgeSub": "{{days}} days",
    "leftoverAskFreezer": "In the freezer",
    "leftoverAskFreezerSub": "{{days}} days · goes to the pantry",
    "leftoverAskNone": "No leftovers",
    "leftoverAskSave": "Save",
    "leftoverFrozenName": "Leftovers — {{recipe}}",
    "previousWeeks": "Previous weeks",
    "backToThisWeek": "Back to this week",
    "weekOfDivider": "Week of {{date}}",
    "scrollEnd": "Twelve weeks ahead is as far as the list goes: everything through {{date}}",
    "addOtherMeal": "Add a meal or a dish",
    "hideOtherMeals": "Show less",
    "extend": {
      "title": "Plan the next 7 days",
      "busy": "Picking your dinners…",
      "range": "{{from}} → {{to}}",
      "added_one": "{{count}} dinner added",
      "added_other": "{{count}} dinners added",
      "nothing": "Nothing to add: those nights are already planned",
      "pendingDay": "Picking your dinner for {{day}}"
    },
    "groceryAsk": {
      "title_one": "Add this dinner to your grocery list?",
      "title_other": "Add these {{count}} dinners to your grocery list?",
      "add": "Add",
      "later": "Later",
      "done": "Grocery list updated"
    },
    "fanTitle": "{{count}} idea for this meal",
    "fanTitle_other": "{{count}} ideas for this meal",
    "orChooseRecipe": "Or choose a recipe",
    "fanEmpty": "No other recipes in your library. Add some to get ideas.",
    "dayProfile": {
      "mon": {
        "tag": "Quick",
        "note": "Busy evening"
      },
      "tue": {
        "tag": "Light",
        "note": "Midweek"
      },
      "wed": {
        "tag": "Varied",
        "note": "A little change"
      },
      "thu": {
        "tag": "Comfort",
        "note": "Thursday night"
      },
      "fri": {
        "tag": "Festive",
        "note": "Start of the weekend"
      },
      "sat": {
        "tag": "Brunch",
        "note": "Weekend"
      },
      "sun": {
        "tag": "Gentle",
        "note": "Sunday"
      }
    },
    "toastNothingPlanned": "Nothing planned that day",
    "toastSlotCleared": "Slot cleared",
    "slotTitle": "{{day}} {{meal}}",
    "swapSuggestion": "Swap suggestion",
    "suggestedFor": "Suggested for",
    "filteredFor": "{{filter}} for",
    "suggestionFilters": {
      "quick": "Quick",
      "veggie": "Vegetarian",
      "fish": "Seafood",
      "favorite": "Favorites",
      "new": "New recipes",
      "cuisine": "Cuisine"
    },
    "findingRecipes": "Finding recipes…",
    "noSuggestions": "No recipes found",
    "noFilteredSuggestions": "No recipes found for “{{filter}}”",
    "seeMoreSuggestions_one": "See {{count}} more suggestion",
    "seeMoreSuggestions_other": "See {{count}} more suggestions",
    "suggestionBadges": {
      "veggie": "Adds variety",
      "fish": "Seafood",
      "favorite": "Favorite",
      "new": "Try new"
    },
    "inProgress": "In progress →",
    "toBuyCount": "{{count}} to buy",
    "youHaveOf": "You have {{have}}/{{total}} ingredients",
    "needToBuyCount": "Need to buy ({{count}}):",
    "markCooked": "Mark as cooked",
    "suggestionFallback": "Showing your library — no exact match for this slot",
    "planDay": "Plan",
    "proteinFish": "Fish",
    "proteinPlantBased": "Plant based",
    "toastPlacedIn": "Added to {{day}} {{meal}}: {{title}}",
    "changeMeal": "Change",
    "addToDay": "Add",
    "addToDayLabel": "Add a meal on {{day}}",
    "mealSlotState": {
      "free": "free",
      "full": "planned",
      "past": "past"
    },
    "backToToday": "Today",
    "markedDone": "Bon appetit! I noted that you cooked {{name}}."
  },
  "mealCard": {
    "fromInventory": "from inventory",
    "usesExpiringItems": "Uses expiring items"
  },
  "groceryList": {
    "title": "Grocery List",
    "generateList": "Generate Grocery List",
    "viewList": "View Grocery List",
    "clearList": "Clear List",
    "addItem": "Add Item",
    "addCustomItem": "Add Custom Item",
    "itemName": "Item Name",
    "category": "Category",
    "cancel": "Cancel",
    "add": "Add",
    "noItemsYet": "No Items Yet",
    "noItemsText": "Your grocery list updates automatically from your meal plan. You can also add items manually.",
    "addFirstItem": "Add custom item",
    "wasteReduction": "Waste Reduction",
    "alreadyHave": "Already Have",
    "ingredients": "Ingredients",
    "estSavings": "Est. Savings",
    "expiring": "Expiring",
    "itemsRemaining": "{{count}} item remaining",
    "itemsRemaining_other": "{{count}} items remaining",
    "percentInKitchen": "{{percent}}% of ingredients already in your kitchen",
    "clearConfirm": "Are you sure you want to clear the entire grocery list?",
    "custom": "Custom",
    "itemNamePlaceholder": "e.g., Extra virgin olive oil",
    "addItemButton": "Add Item",
    "addCustomItemTitle": "Add Custom Item",
    "categories": {
      "produce": "Produce",
      "dairy": "Dairy",
      "meat": "Meat",
      "bakery": "Bakery",
      "pantry": "Pantry",
      "spices": "Spices",
      "frozen": "Frozen",
      "beverages": "Beverages",
      "other": "Other"
    },
    "addAnItem": "Add an item",
    "basedOnServings": "Based on {{count}} servings per meal",
    "byRecipe": "By Recipe",
    "byCategory": "By aisle",
    "otherItems": "Other Items",
    "clear": "Clear",
    "clearListTitle": "Clear List",
    "clearListMessage": "Clear all {{count}} items?",
    "clearAll": "Clear All",
    "noItemsToCopy": "No items to copy. All items are checked off!",
    "copiedToClipboard": "Copied {{count}} ingredients to clipboard",
    "updating": "Updating your list...",
    "listOutOfDate": "List may be out of date",
    "addFromRecipes": "Your grocery list updates automatically from your meal plan. You can also add items manually.",
    "noLufaMatchesTitle": "No Lufa Matches",
    "noLufaMatchesText": "None of your grocery items match Lufa Farms deals this week.",
    "availableAtLufa": "Available at Lufa Farms",
    "shopAll": "Shop All",
    "forRecipes": "For: {{recipes}}",
    "quickAddPlaceholder": "Quick add item...",
    "quickAddButton": "Add",
    "inYourInventory": "In Your Inventory",
    "confirmedByYou": "Confirmed by You",
    "kitchenStaples": "Kitchen Staples",
    "inStock": "{{count}} in stock",
    "inStockNeed": "{{count}} in stock (need {{needed}})",
    "autoBannerLead": "Built from your plan.",
    "autoBannerLeadFromToday": "Built from your plan, from today to {{end}}.",
    "autoBannerLeadTodayOnly": "Built from your plan, for today only.",
    "autoBannerRemovedOne": "We removed {{part}}.",
    "autoBannerRemovedBoth": "We removed {{pantry}} and {{staples}}.",
    "autoBannerPantryPart": "{{count}} item from your pantry",
    "autoBannerPantryPart_other": "{{count}} items from your pantry",
    "autoBannerStaplePart": "{{count}} kitchen staple ({{examples}})",
    "autoBannerStaplePart_other": "{{count}} kitchen staples ({{examples}})",
    "staples": {
      "salt": "Salt",
      "pepper": "Pepper",
      "oil": "Oil",
      "olive-oil": "Olive Oil",
      "vegetable-oil": "Vegetable Oil",
      "flour": "Flour",
      "cornstarch": "Cornstarch",
      "sugar": "Sugar",
      "brown-sugar": "Brown Sugar",
      "baking-soda": "Baking Soda",
      "vanilla-extract": "Vanilla Extract",
      "oregano": "Oregano",
      "thyme": "Thyme",
      "basil": "Dried Basil",
      "parsley": "Dried Parsley",
      "cumin": "Cumin",
      "coriander": "Ground Coriander",
      "paprika": "Paprika",
      "cinnamon": "Cinnamon",
      "nutmeg": "Nutmeg",
      "cayenne": "Cayenne",
      "garam-masala": "Garam Masala",
      "turmeric": "Turmeric",
      "bay-leaf": "Bay Leaf",
      "red-pepper-flakes": "Red Pepper Flakes",
      "herbes-de-provence": "Herbes de Provence",
      "italian-seasoning": "Italian Seasoning",
      "markMissing": "I don't have it",
      "excludedToast": "{{name}} added to your list"
    },
    "autoSealNow": "Auto · just now",
    "autoSealMin": "Auto · {{count}} min ago",
    "autoSealMin_other": "Auto · {{count}} min ago",
    "autoSealHours": "Auto · {{count}} h ago",
    "autoSealHours_other": "Auto · {{count}} h ago",
    "footerTaken": "taken",
    "footerRemaining": "remaining",
    "storePurchases": "Put purchases away",
    "storedPurchasesToast": "{{count}} item put away in pantry",
    "storedPurchasesToast_other": "{{count}} items put away in pantry",
    "rayons": {
      "produce": "Fruits & vegetables",
      "meat": "Meat & fish",
      "fresh": "Fresh",
      "grocery": "Grocery",
      "other": "Other"
    },
    "translationPending": "Translating ingredient"
  },
  "language": {
    "english": "English",
    "french": "Français",
    "changeLanguage": "Change Language",
    "currentLanguage": "Current Language",
    "changing": "Changing language..."
  },
  "common": {
    "loading": "Loading...",
    "error": "Error",
    "retry": "Retry",
    "ok": "OK",
    "yes": "Yes",
    "no": "No",
    "minutes": "{{count}}m",
    "hours": "{{count}}h",
    "hoursAndMinutes": "{{hours}}h {{minutes}}m",
    "close": "Close",
    "done": "Done",
    "expiring": "expiring",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "confirm": "Confirm",
    "search": "Search",
    "dismiss": "Dismiss",
    "back": "Back",
    "undo": "Undo",
    "noItems": "No items selected",
    "selectAtLeastOne": "Please accept at least one food item to add to your inventory.",
    "gotIt": "Got it",
    "tapToRefresh": "Tap to refresh",
    "pageNotFound": "Page not found",
    "itemNotFound": "Item not found",
    "viewList": "View list",
    "cooked": "COOKED",
    "prep": "PREP",
    "total": "TOTAL",
    "today": "TODAY",
    "all": "All",
    "veggie": "Veggie",
    "under30": "≤ 30 min",
    "ingredientsAdded_one": "{{count}} ingredient added to your list",
    "ingredientsAdded_other": "{{count}} ingredients added to your list",
    "somethingWentWrong": "Something went wrong",
    "redirecting": "Redirecting…"
  },
  "errors": {
    "signedOut": "You're no longer signed in. Sign in again and retry.",
    "serverError": "Something went wrong on our side. Please try again in a moment.",
    "networkError": "Network error. Please check your connection.",
    "unknownError": "An unexpected error occurred.",
    "recipeNotFound": "Recipe not found.",
    "translationFailed": "Translation failed. Please try again.",
    "cameraPermission": "Camera permission is required.",
    "imageProcessingFailed": "Failed to process image.",
    "languageChangeFailed": "Failed to change language. Please try again."
  },
  "onboarding": {
    "brand": "Du Chef",
    "quiz": {
      "hello": "Hi, Chef! Three duels and I build your personalized meal recommendations.",
      "haveAccount": "I already have an account",
      "kicker": "Your profile",
      "axis": {
        "base": "What you build meals around",
        "time": "How much time you spend",
        "heat": "The intensity"
      },
      "question": {
        "q1": "Which of the two dishes interests you most?",
        "q2": "On a weeknight, which one?",
        "q3": "And to finish?"
      },
      "reaction": {
        "q1a": "Okay, protein stays at the center.",
        "q1b": "Ah, plants first. Interesting.",
        "q2a": "Sounds like quick meals are your thing on weeknights.",
        "q2b": "Looks like you don't mind spending time at the stove.",
        "q3a": "You seem to like things spiced up.",
        "q3b": "More on the mild side—got it."
      },
      "progress": "Question {{n}} / 3",
      "choose": "Choose",
      "ingredients": "{{count}} ingredients",
      "minutes": "{{count}} min",
      "difficulty": {
        "facile": "easy",
        "moyen": "medium",
        "technique": "advanced"
      },
      "side": {
        "protein": "Protein at the centre",
        "vegetal": "Vegetables first",
        "bold": "Bold flavours",
        "mild": "Mild flavours"
      }
    },
    "safety": {
      "kicker": "Before I suggest anything",
      "prompt": "Any important allergies I should know about?",
      "sectionKicker": "Allergies & Intolerances",
      "allergen": {
        "arachides": "Peanuts",
        "noix": "Tree Nuts",
        "crustaces": "Shellfish",
        "lactose": "Lactose",
        "gluten": "Gluten",
        "oeufs": "Eggs",
        "soja": "Soy",
        "poisson": "Fish",
        "sesame": "Sesame"
      },
      "otherPlaceholder": "Other allergy or intolerance…",
      "add": "Add",
      "nothing": "Nothing to report",
      "confirm": "Confirm",
      "beat": "Building your profile…",
      "beatReading": "Reading your answers…",
      "beatWeek": "Building your week…",
      "beatAllergies": "Without {{list}}",
      "beatNoAllergies": "Nothing to avoid",
      "beatError": "Oops, let's try again.",
      "beatEmpty": "Your exclusions leave no recipe in your library. Remove one and I'll build your week.",
      "retry": "Retry",
      "editExclusions": "Edit my exclusions",
      "promise": "I never treat these approximately: a dish that contains one is never suggested, not in the week, not in search."
    },
    "direction": {
      "kicker": "Your profile is ready",
      "title": "What do you want to do",
      "titleEmphasis": "now",
      "titleEnd": "?",
      "planCta": "Plan my week",
      "ideasCta": "Find me dinner for tonight",
      "searchPlaceholder": "Chicken, rice, broccoli…",
      "chips": {
        "quick": "≤ 20 min",
        "fridge": "In my fridge",
        "rated": "Highly rated",
        "veg": "Veg"
      },
      "nothingPlanned": "Nothing planned",
      "planSub": "Seven dinners and the grocery list",
      "ideasSub": "With what you already have",
      "ideasSubPicked": "Ideas that fit your profile",
      "ideaMinutes": "{{minutes}} min",
      "bubble": "I can build your whole week, or just find you something for tonight."
    },
    "profile": {
      "kicker": "Your profile",
      "bubble": "Here is what I understood. Correct me if I got it wrong.",
      "axis": {
        "base": "The base",
        "time": "The time",
        "heat": "The intensity"
      },
      "title": "Does this sound like you?",
      "flipHint": "A line that isn’t you? Tap it and I’ll fix it.",
      "allergiesKicker": "Allergies and intolerances",
      "none": "Nothing to report",
      "edit": "Edit",
      "peopleKicker": "How many people do you usually cook for?",
      "people_one": "person",
      "people_other": "people",
      "fewer": "One person fewer",
      "more": "One more person",
      "confirm": "That’s me"
    },
    "reading": {
      "base": {
        "protein": "Looks like you're all about protein — {{plate1}} over {{other1}}.",
        "vegetal": "I sense you're drawn to vegetables — you picked {{plate1}} instead of {{other1}}."
      },
      "time": {
        "quick": "And since you picked {{plate2}} ({{min2}} min) over {{other2}} ({{minOther2}} min), I'm guessing you don't want to spend all evening cooking.",
        "long": "And since you went for {{plate2}} and its {{min2}} minutes, I figure real cooking doesn't bother you."
      },
      "heat": {
        "bold": "I'm going to lean into bold, spiced-up flavors — tell me if I'm off.",
        "mild": "I'm sticking to gentle flavors — let me know if that's wrong."
      },
      "corrected": {
        "base": "Adjusted your foundation. Building from there.",
        "time": "Adjusted your time preference. Building from there.",
        "heat": "Adjusted the heat. Building from there."
      },
      "concretementKicker": "In practice",
      "concretement": {
        "protein-quick-bold": "I keep to the pan and the grill on weeknights, short marinades, and save the oven for Saturday.",
        "protein-quick-mild": "Quick stovetop cooking, lemon and herb sauces rather than heat.",
        "protein-long-bold": "Bold braised meat on weekends, and I'll give you a heads-up Friday to thaw.",
        "protein-long-mild": "Gentle roasts that work themselves in the oven, plus leftovers for later.",
        "vegetal-quick-bold": "Wok sautés, bold spices, legumes for staying power — twenty minutes every time.",
        "vegetal-quick-mild": "Warm vegetable bowls, lemon and herbs, nothing spicy.",
        "vegetal-long-bold": "Curries and long-roasted vegetables, whole spices, plenty of leftovers.",
        "vegetal-long-mild": "Vegetable gratins and simmering soups, all gentle."
      },
      "chip": {
        "base": {
          "protein": "Protein first",
          "vegetal": "Plants first"
        },
        "time": {
          "quick": "≤ 30 min on weeknights",
          "long": "Take your time"
        },
        "heat": {
          "bold": "Bold flavors",
          "mild": "Gentle flavors"
        }
      },
      "hint": "One of these doesn't fit you? Tap it, and I'll rebuild the week.",
      "close": "Close"
    }
  },
  "diet": {
    "vegetarian": "Vegetarian",
    "vegetarianDesc": "No meat or seafood",
    "vegan": "Vegan",
    "veganDesc": "No animal products",
    "glutenFree": "Gluten-free",
    "glutenFreeDesc": "No wheat, barley, or rye",
    "dairyFree": "Dairy-free",
    "dairyFreeDesc": "No milk, cheese, or cream",
    "navTitle": "Dietary preferences",
    "dietType": "Diet type",
    "excludedIngredients": "Excluded ingredients",
    "noExcluded": "No excluded ingredients yet.",
    "mealFrequency": "Meal frequency",
    "noFrequency": "No frequency preferences yet.",
    "addMore": "Add more",
    "addMoreHint": "e.g. \"I'm allergic to shellfish\" or \"2 vegetarian meals per week\"",
    "addMorePlaceholder": "Type any dislikes, allergies, or frequency...",
    "parse": "Parse",
    "understood": "We understood — tap to remove:",
    "nothingDetected": "No specific preferences detected.",
    "save": "Save preferences",
    "vegetarianPerWeek": "{{count}} vegetarian/week",
    "fishPerWeek": "{{count}} fish/week",
    "filterCoverage": "Vegetarian is matched on a recipe's ingredients, so it filters the whole library. Gluten-free and dairy-free are matched on what a recipe states about itself, which few state — expect a much shorter list. You can lift a diet for one session from the chip on the Recipes screen.",
    "lowLactose": "Low lactose",
    "healthy": "Healthy"
  },
  "join": {
    "headline": "Your partner invited you",
    "subline": "Plan meals, sync your grocery list, and cook together.",
    "featurePlan": "Shared weekly meal plan",
    "featureGrocery": "Grocery list syncs in real time",
    "featureRecipes": "Save and rate recipes together",
    "featurePantry": "One pantry, no duplicates",
    "createAccount": "Create free account",
    "haveAccount": "Already have an account? Sign in",
    "alreadyPairedTitle": "You're already paired",
    "alreadyPairedBody": "You and your partner are already sharing this household.",
    "continue": "Continue",
    "otherHouseholdTitle": "You're already in a household",
    "otherHouseholdBody": "You can only be in one household at a time. Leave your current household first to accept this invite.",
    "backToApp": "Back to app",
    "headerTitle": "Join household",
    "lookingUp": "Looking up invite…",
    "invitedTitle": "You've been invited",
    "invitedSubtitle": "You'll share meal plan, recipes, grocery list, ratings, and pantry.",
    "dataQuestion": "What about your data?",
    "mergeTitle": "Merge",
    "mergeBody": "Combine my recipes, lists, and pantry with theirs. Last edit wins on overlapping items.",
    "freshTitle": "Start fresh",
    "freshBody": "Use their setup. Nothing of mine is deleted — I can get it back later.",
    "joining": "Joining household…",
    "cancel": "Cancel",
    "errMissingCode": "Missing invite code.",
    "errNotFound": "Invite not found. Ask your partner to send a fresh link.",
    "errUsed": "This invite has already been used.",
    "errExpired": "This invite has expired. Ask your partner to send a fresh one.",
    "errLoad": "Could not load invite.",
    "errJoin": "Could not join household."
  },
  "wizard": {
    "mealSlotQuestion": "Which meals did you want to\ninclude for these days?",
    "dietaryTitle": "Any dietary preferences?",
    "dietarySubtitle": "Select any options that apply to your week",
    "vegetarian": "Vegetarian",
    "vegetarianDesc": "Include at least one vegetarian meal",
    "fishSeafood": "Fish/Seafood",
    "fishSeafoodDesc": "Include at least one fish or seafood meal",
    "surpriseMe": "Surprise me!",
    "surpriseMeDesc": "No preference - let me discover new recipes",
    "portionTitle": "How many servings per meal?",
    "portionSubtitle": "This will apply to all generated recipes",
    "servings": "servings",
    "custom": "custom",
    "enterServings": "Enter number of servings",
    "back": "Back",
    "next": "Next",
    "generate": "Generate",
    "generating": "Generating..."
  },
  "settings": {
    "subtitle": "App preferences and account",
    "mealSchedule": "Meal Schedule",
    "reset": "Reset",
    "mealScheduleDescription": "Set your preferences for each day of the week. The meal planner will respect these when generating your weekly plan.",
    "dinnerTime": "Dinner time",
    "mealType": "Meal type",
    "maxCookTime": "Max cook time",
    "noLimit": "No limit",
    "prepAheadOk": "Prep-ahead OK",
    "kidsPresent": "Kids present",
    "defaultServings": "Default servings",
    "defaultServingsDescription": "New meals will default to this number of servings",
    "servings": "servings",
    "mealDietTypes": {
      "any": "Any",
      "meat": "Meat",
      "vegetarian": "Veggie",
      "fish": "Fish",
      "pasta": "Pasta",
      "quick": "Quick"
    },
    "emailImportTitle": "Forward recipes by email",
    "emailImportDescription": "Forward any recipe newsletter to this address and Du Chef will automatically import the recipes.",
    "emailImportCopy": "Copy address",
    "emailImportCopied": "Copied!",
    "helpFeedback": "Help & Feedback",
    "reportProblem": "Report a Problem",
    "reportProblemDescription": "Something not working right? Send us a description and we'll look into it.",
    "notifications": "Notifications",
    "dailyEmail": "Du Chef Daily email",
    "dailyEmailDesc": "A nightly note with tomorrow's plan and a food fact.",
    "dietaryPreferences": "Dietary preferences",
    "noRestrictions": "No restrictions set",
    "excludedIngredientCount": "{{count}} excluded ingredient",
    "excludedIngredientCount_other": "{{count}} excluded ingredients",
    "noExcludedIngredients": "No excluded ingredients",
    "kitchenStaples": "Kitchen staples",
    "kitchenStaplesDesc": "Toggle which kitchen staples we assume you have in stock. Items that are toggled ON are not included in your grocery list.",
    "excludedStapleCount": "{{count}} staple excluded",
    "excludedStapleCount_other": "{{count}} staples excluded",
    "noExcludedStaples": "All staples are assumed in stock",
    "syncing": "Syncing...",
    "syncComplete": "Sync complete",
    "forceSync": "Force sync meals to cloud",
    "syncFailed": "Sync failed. Please try again.",
    "pantryTitle": "Pantry",
    "labs": {
      "title": "Labs",
      "description": "Experimental features. Visible only to you.",
      "skylightDestination": "Family Calendar",
      "push": "Send the week of {{week}}",
      "noGroceryList": "No grocery list generated",
      "weekNotPlanned": "Week of {{week}} is not planned",
      "phaseRecipes": "Recipes… {{done}}/{{total}}",
      "phaseDeletions": "Cleaning up… {{done}}/{{total}}",
      "phaseMeals": "Meals… {{done}}/{{total}}",
      "phaseGroceries": "Groceries… {{done}}/{{total}}",
      "done": "{{recipes}} recipes · {{meals}} meals · {{groceries}} lines",
      "doneMealsSkipped": "Groceries sent · meals skipped",
      "doneNoMeals": "Groceries sent · no meals were sent for this week",
      "doneSomeMealsMissing": "Groceries sent · {{count}} meal could not be sent",
      "doneSomeMealsMissing_other": "Groceries sent · {{count}} meals could not be sent",
      "unresolvedHint": "Their recipes could not be found. The rest of the week was sent.",
      "failed": "Push interrupted — try again"
    },
    "myTasteTitle": "My taste",
    "myTasteEmpty": "Not set yet"
  },
  "tasteProfile": {
    "title": "My taste profile",
    "signals": "{{count}} signals",
    "updated": "Updated {{date}}",
    "noProfile": "I haven't learned anything yet",
    "noProfileText": "Tell me what you think of my suggestions — skip, replace or edit a meal — and I'll start reading you.",
    "buildingProfile": "I'm starting to read you",
    "buildingProfileText": "I have {{count}} signal{{plural}}. A few more gestures and I'll write down what I understood. Pull down to refresh.",
    "preferences": "Preferences",
    "recentInsights": "Recent Insights",
    "howItsImproving": "How It's Improving",
    "showLess": "Show less",
    "showMore": "Show {{count}} more",
    "chosenTitle": "What you chose",
    "chosenHint": "A line that isn't you? Tap it, I'll fix it.",
    "chosenSaved": "Noted. Your next week will follow it.",
    "declaredTitle": "What you ruled out",
    "allergiesLabel": "Allergies and intolerances",
    "dietsLabel": "Diets",
    "dietsNone": "No diet declared",
    "excludedCount": "{{count}} excluded ingredient",
    "excludedNone": "No excluded ingredient",
    "declaredNote": "Never suggested, never on your grocery list — including when you regenerate the week.",
    "learnedTitle": "What I've picked up watching you",
    "learnedNote": "I use it to rank my suggestions, never to rule a dish out.",
    "excludedCount_other": "{{count}} excluded ingredients"
  },
  "addRecipe": {
    "title": "Add a recipe",
    "pastePlaceholder": "Recipe or video link",
    "invalidUrl": "Please enter a valid URL",
    "fetchingRecipe": "Fetching recipe...",
    "analyzingVideo": "Analyzing video...",
    "videoHint": "This may take 30-60 seconds",
    "savingRecipe": "Saving to your recipes...",
    "addRecipeButton": "Add to my recipes",
    "addButton": "Add",
    "tryAgain": "Try again",
    "loginRequired": "You need to log in to save recipes",
    "logIn": "Log in",
    "ingredientsCount": "{{count}} ingredients",
    "addManually": "Add manually",
    "newRecipeTitle": "New Recipe",
    "errorTimeout": "This recipe is taking too long to fetch. Please try again.",
    "errorNetwork": "Couldn't reach the server. Check your connection and try again.",
    "pasteText": {
      "title": "Paste the recipe instead",
      "body": "Open the post in {{platform}}, copy the recipe from the caption or the comments, and paste it here.",
      "theApp": "the app",
      "placeholder": "Ingredients and steps, as written in the post",
      "cta": "Import this text"
    },
    "errors": {
      "blocked": "This site doesn't allow recipes to be imported automatically. You can add it manually instead.",
      "unscrapable": "This site doesn't publish recipe details we can read. You can add the recipe manually instead.",
      "extractionFailed": "We couldn't find a recipe on this page. Check the link, or add the recipe manually.",
      "loginWall": "This site keeps this recipe for its signed-up members. You can add it manually instead.",
      "invalidUrl": "That link doesn't look like a recipe page. Please check it and try again.",
      "timeout": "This recipe is taking too long to fetch. Please try again.",
      "unknown": "Could not fetch recipe from this URL.",
      "authRequired": "Create a free account to import recipes.",
      "quotaExceeded": "You've reached today's import limit. Please try again tomorrow."
    },
    "linkDetected": "Copied link",
    "pasteLink": "Paste the link",
    "changeLink": "Another link",
    "fromPhoto": "Photo",
    "takePhoto": "Camera",
    "signInWall": {
      "title": "Create an account to import",
      "body": "Importing pulls the recipe in and saves it to your collection, so it needs somewhere to live. It takes a few seconds and your meal plan comes with you.",
      "cta": "Create a free account",
      "signIn": "I already have an account",
      "keepBrowsing": "Not now",
      "scanTitle": "Create an account to scan a recipe",
      "scanBody": "Reading a photo of a recipe and saving it to your collection needs an account. It takes a few seconds and your meal plan comes with you."
    },
    "anotherLinkPlaceholder": "Or another link",
    "paste": "Paste",
    "writeIt": "Write it",
    "saveFailed": "Couldn't save the recipe",
    "createFailed": "Couldn't create the recipe"
  },
  "recipeDetail": {
    "myRating": "My Rating",
    "prepTime": "Prep Time",
    "cookTime": "Cook Time",
    "totalTime": "Total Time",
    "skillLevel": "Skill Level",
    "estimatedCalories": "Est. Calories",
    "ingredients": "Ingredients",
    "haveAllIngredients": "Have all ingredients?",
    "metric": "metric",
    "imperial": "imperial",
    "adjusted": "Adjusted",
    "adjustedServings": "{{from}} → {{to}} servings",
    "reset": "reset",
    "resetToOriginal": "Restore the original recipe",
    "originallyValue": "originally: {{value}}",
    "swap": "sub",
    "addToMealPlan": "Add to Meal Plan",
    "instructionsNotAvailable": "Instructions not available in-app.",
    "viewOnOriginalSite": "View on original site",
    "noInstructionsAdded": "No instructions added",
    "updateFromSource": "Update from {{source}}",
    "editRecipe": "Edit Recipe",
    "alreadyOnPlan": "● already on this plan",
    "alreadyScheduledTitle": "Already on {{where}}",
    "alreadyScheduledSubtitle": "Move it to this slot, or add a second copy?",
    "moveHere": "Move here",
    "addAnother": "Add another",
    "movedToSlot": "Moved to {{mealType}} on {{date}}",
    "slotOccupiedTitle": "This slot already has a meal",
    "slotAlreadyHolds": "Already planned: {{dishes}}.",
    "swapHere": "Swap the two",
    "slotFullReason": "This slot already holds 3 dishes",
    "entryOwnsSlotReason": "That day is set to something else",
    "swappedWithSlot": "{{title}} swapped with {{other}}",
    "replacedAtSlot": "{{title}} replaced {{other}}",
    "stackedAtSlot": "{{title}} added alongside {{other}}",
    "replaceHere": "Replace",
    "replaceSlot_one": "Replace",
    "replaceSlot_other": "Replace all {{count}}",
    "addToSlot": "Add to slot",
    "logPastMeal": "log a meal",
    "pastDayCookedTitle": "Did you cook this recipe on {{day}}?",
    "pastDayCookedSubtitle": "That day is over. If you did, I'll note it as cooked on that day.",
    "pastDayCookedYes": "Yes, I cooked it",
    "pastDayCookedNo": "No, pick another day",
    "pastMealsScrollHint": "↑ Past meals",
    "cookHistoryCooked": "Cooked {{count}} time",
    "cookHistoryCooked_other": "Cooked {{count}} times",
    "cookHistoryLastCooked": "Last cooked {{when}}",
    "cookHistoryNever": "Never cooked yet",
    "cookHistoryLastWeek": "last week",
    "cookHistoryWeeksAgo": "{{count}} week ago",
    "cookHistoryWeeksAgo_other": "{{count}} weeks ago",
    "cookHistoryLongAgo": "a while ago",
    "cookHistoryAll": "All →",
    "logCooked": "I cooked this",
    "coveragePrefix": "You're missing ",
    "ingredientWord": "ingredient",
    "ingredientsWord": "ingredients",
    "coverageAllPrefix": "You have ",
    "coverageAllWord": "everything",
    "coverageAllSuffix": " you need",
    "coverageSub": "Crossed with your pantry — you already have the other {{count}} (staples included).",
    "coverageSub_other": "Crossed with your pantry — you already have the other {{count}} (staples included).",
    "coverageSubAll": "Crossed with your pantry — staples included.",
    "addBuyToGrocery": "Add {{count}} to groceries",
    "addBuyToGrocery_other": "Add {{count}} to groceries",
    "legendHave": "Already home",
    "legendBuy": "To buy",
    "editPantry": "Edit my pantry",
    "replaceRow": "swap",
    "replacing": "swapping",
    "correctionHaveQuestion": "Already have “{{name}}”?",
    "correctionHaveAction": "I have it — add to pantry",
    "correctionOutQuestion": "In your pantry: “{{item}}”",
    "correctionOutAction": "I'm out of it",
    "correctionOutNextQuestion": "There's also “{{item}}”. Out of that too?",
    "correctionOutNextAction": "Yes, it's gone",
    "correctionOutNextKeep": "No, I have it",
    "correctionStapleQuestion": "Assumed staple — out of stock?",
    "correctionStapleAction": "Add to groceries",
    "removedFromPantryToast": "{{name}} — removed from pantry",
    "addedToPantryToast": "{{name}} — added to pantry",
    "share": "Share",
    "linkCopied": "Link copied",
    "shareInPaprika": "In Du Chef:",
    "more": "More",
    "favorite": "Favorite",
    "logCook": "Log a cook",
    "openOnSource": "Open on {{source}}",
    "sourceFallback": "the source site",
    "viewInPlan": "View in plan",
    "cookMode": "Cook mode",
    "plan": "Plan",
    "showMore": "Read more",
    "showLess": "Show less",
    "deleteTitle": "Delete recipe",
    "deleteConfirm": "Delete \"{{title}}\"? This cannot be undone.",
    "deleted": "Recipe deleted: “{{title}}”",
    "servingsCount_one": "{{count}} serving",
    "servingsCount_other": "{{count}} servings",
    "durationMinutes_one": "{{count}} min",
    "durationMinutes_other": "{{count}} min",
    "durationHours_one": "{{count}} h",
    "durationHours_other": "{{count}} h",
    "cookedTimes_one": "Cooked {{count}} time",
    "cookedTimes_other": "Cooked {{count}} times",
    "cookedLastTime": "last on {{date}}",
    "buyPill_one": "{{count}} to buy",
    "buyPill_other": "{{count}} to buy",
    "nothingInPantry": "None of it is in your pantry.",
    "restInPantry_one": "The other one is in your pantry.",
    "restInPantry_other": "The other {{count}} are in your pantry.",
    "haveEverything": "You have everything you need.",
    "slotMorning": "breakfast",
    "slotNoon": "lunch",
    "slotEvening": "dinner",
    "addBuyToGrocery_one": "Add {{count}} to groceries",
    "loading": "Loading recipe…",
    "notFound": "Recipe not found",
    "loadFailed": "Couldn't load this recipe",
    "noIngredientsListed": "No ingredients listed",
    "fetchingFromSource": "Fetching from source…",
    "dataError": {
      "section": {
        "ingredients": "ingredients",
        "steps": "steps"
      },
      "openSource": "Open source URL",
      "editManually": "Edit manually",
      "blocked": {
        "title": "This site blocks automated access",
        "body": "The source site doesn't allow scraping. Open the original recipe to copy the details manually."
      },
      "network": {
        "title": "Couldn't reach the source",
        "body": "The request timed out or the site is temporarily unavailable. Check your connection and try again."
      },
      "notFound": {
        "title": "Couldn't extract recipe data",
        "body": "The page loaded but the {{section}} weren't in a recognizable format. Try again, open the original, or add them manually."
      },
      "signIn": {
        "title": "Create an account to load this recipe",
        "body": "Du Chef fetches the recipe from the original site, and it needs an account for that. It is free."
      }
    },
    "moveMealTitle": "Move this meal",
    "mealIsHere": "This meal is here",
    "planSecondTime": "Plan a second time",
    "removeFromPlan": "Remove from plan",
    "removedFromPlan": "Removed from plan",
    "addedToSlot": "Added to {{mealType}} on {{date}}",
    "planFailed": "Could not add to the plan",
    "addIngredient": "Add an ingredient",
    "addStep": "Add a step",
    "changePhoto": "Change photo",
    "deleteRecipe": "Delete recipe",
    "descriptionLabel": "DESCRIPTION",
    "descriptionPlaceholder": "A short description…",
    "editHint": "Your changes are only saved when you confirm.",
    "noSubstitutes": "No common substitute for this ingredient.",
    "replace": "REPLACE",
    "servings": "SERVINGS",
    "servingsLabel": "SERVINGS",
    "stepPlaceholder": "Describe this step…",
    "steps": "Preparation",
    "substituteFooter": "Your choice updates your grocery list.",
    "substituteHint": "Adjust the quantity as noted.",
    "titleLabel": "TITLE",
    "use": "Use",
    "used": "Used",
    "veg": "veg",
    "savedToast": "A new potential feast in your library!",
    "mustBeLoggedIn": "You must be logged in to edit recipes",
    "noItemsToAdd": "No items to add",
    "addToGroceryFailed": "Failed to add items to grocery list",
    "recipeUpdated": "Recipe updated with missing data",
    "alreadyInPantryToast": "{{name}} — already in the pantry",
    "alreadyInPantryAsToast": "{{name}} — already in the pantry as {{existing}}",
    "stapleNotShelvedToast": "{{name}} — a kitchen staple, always counted as in stock",
    "notShelvedToast": "{{name}} — couldn't be added to the pantry",
    "coverageQuestion": "Use \"{{item}}\" for \"{{need}}\"?",
    "coverageYes": "Yes, I'm covered",
    "coverageNo": "No, buy it",
    "inYourPantry": "In your pantry",
    "otherOptions": "Other options",
    "moreCookNotes_one": "{{count}} more note",
    "moreCookNotes_other": "{{count}} more notes",
    "coverageYield": "{{owned}} ≈ {{available}} {{unit}}",
    "coverageYieldNeeded": "{{owned}} ≈ {{available}} {{unit}} — you need {{needed}}",
    "watch": "Watch",
    "watchOriginalVideo": "Watch original video",
    "newRecipeTitle": "New recipe",
    "newRecipeHint": "Nothing is kept until you save.",
    "addPhoto": "Add a photo",
    "titlePlaceholder": "Recipe name",
    "ingredientLinePlaceholder": "e.g. 3 cups tomato sauce",
    "removeIngredient": "Remove this ingredient",
    "ingredientReadAs": "Read as",
    "sourceLabel": "SOURCE (OPTIONAL)",
    "sourceAuthorLabel": "AUTHOR",
    "sourceAuthorPlaceholder": "Who wrote the recipe",
    "sourceLinkLabel": "LINK",
    "addUnit": "+ unit",
    "addQuantity": "+ quantity",
    "ingredientCorrected": "Fixed",
    "unitLabel": "UNIT",
    "unitNone": "none",
    "unitOther": "Other…",
    "unitOtherPlaceholder": "e.g. drizzle",
    "quantityLabel": "QUANTITY",
    "quantityLess": "Less",
    "quantityMore": "More"
  },
  "recipeTime": {
    "handsOn": "Hands-on",
    "ready": "Ready in",
    "moments_one": "in {{count}} go",
    "moments_other": "in {{count}} goes",
    "oneGo": "in one go",
    "noWait": "nothing to wait for",
    "waitCaption": {
      "marinade": "including {{range}} marinating in the fridge",
      "fridge": "including {{range}} in the fridge",
      "rise": "including {{range}} rising",
      "rest": "including {{range}} resting",
      "soak": "including {{range}} soaking",
      "cure": "including {{range}} curing in the fridge",
      "freeze": "including {{range}} in the freezer",
      "oven": "including {{range}} in the oven",
      "simmer": "including {{range}} simmering",
      "slow-cooker": "including {{range}} in the slow cooker",
      "other": "including {{range}} of waiting"
    },
    "cardHandsOn": "Hands-on {{time}}",
    "cardReady": "Ready in {{time}}",
    "rangeMinutes": "{{min}} to {{max}} min",
    "rangeHours": "{{min}} to {{max}} h",
    "rangeMixed": "{{min}} to {{max}}",
    "rangeUpTo": "up to {{max}}"
  },
  "generationSummary": {
    "howPlanBuilt": "How your plan was built",
    "tasteMeals": "{{count}} meal matched your taste preferences",
    "tasteMeals_other": "{{count}} meals matched your taste preferences",
    "inventoryMeals": "{{count}} meal uses items from your pantry",
    "inventoryMeals_other": "{{count}} meals use items from your pantry",
    "dealsIncluded": "{{count}} deal included this week",
    "dealsIncluded_other": "{{count}} deals included this week",
    "cuisineVariety": "{{count}} different cuisines this week",
    "coverageSummary": "Avg {{avgPercent}}% coverage — {{toBuyCount}} items to buy across {{mealCount}} meals"
  },
  "weekRecap": {
    "title": "Week in Review",
    "noMeals": "No meals found for this week.",
    "noneCooked": "Tap each meal you cooked this week, then rate it.",
    "summary": "You cooked {{cooked}} of {{total}} planned meals.",
    "done": "Done",
    "cooked": "Cooked",
    "notCooked": "Not cooked"
  },
  "feedback": {
    "badgeLabel": "ALPHA",
    "sheetTitle": "Share feedback",
    "sheetSubtitle": "You're an alpha tester — your input shapes what gets built next.",
    "bug": {
      "label": "Something broke",
      "description": "Report a bug or unexpected behavior",
      "placeholder": "What went wrong? What did you expect instead?"
    },
    "feature": {
      "label": "Feature idea",
      "description": "Suggest something that would help you",
      "placeholder": "What would make this better?"
    },
    "impression": {
      "label": "Quick thought",
      "description": "Any general impression or comment",
      "placeholder": "What's on your mind?"
    },
    "send": "Send feedback",
    "retry": "Try again",
    "error": "Your feedback couldn't be sent. It's still here — check your connection and try again.",
    "success": "Thanks for your feedback!"
  },
  "cookingPlan": {
    "dinner": "Dinner",
    "pantryAutoUpdated": "Pantry updated automatically",
    "removedFromPantry": "Removed from pantry",
    "viewPantry": "View pantry",
    "undoUpdate": "Undo the update",
    "yesWithoutUpdate": "Yes, without updating",
    "noNotCooked": "No, didn't cook it",
    "noItemsMatched": "No pantry item could be matched.",
    "depleted": "used up",
    "updating": "Updating…",
    "yesUpdatePantry": "Yes, update the pantry",
    "cookedQuestion": "Did you cook {{recipe}}?",
    "thisMeal": "this meal",
    "updatePantryHint": "You can update your pantry automatically.",
    "staplesNotTracked": "Salt, pepper, oil and herbs are not tracked.",
    "resume": "Resume cooking",
    "planThisMeal": "Plan this meal",
    "startMeta": "≈ {{minutes}} min · {{steps}}"
  },
  "recipe": {
    "translating": "Translating…",
    "showTranslation": "Translated"
  },
  "pantry": {
    "title": "Pantry",
    "itemsCount_one": "{{count}} item",
    "itemsCount_other": "{{count}} items",
    "upToDate": "up to date",
    "autoLine": "Updates itself — added when you shop, removed when you cook.",
    "added": {
      "today": "Added today",
      "yesterday": "Added yesterday",
      "days_one": "Added {{count}} day ago",
      "days_other": "Added {{count}} days ago",
      "on": "Added {{date}}"
    },
    "import": {
      "title": "Lufa basket from {{date}}",
      "titleNoDate": "Lufa basket",
      "subtitle_one": "{{count}} item added",
      "subtitle_other": "{{count}} items added",
      "cta": "Review",
      "dismiss": "Dismiss",
      "reviewSub": "Uncheck what didn't arrive · tap a space to move it",
      "later": "Later",
      "keep_one": "Keep {{count}} item",
      "keep_other": "Keep {{count}} items",
      "reviewedToast_one": "Basket reviewed · {{count}} item in your pantry",
      "reviewedToast_other": "Basket reviewed · {{count}} items in your pantry"
    },
    "mySpaces": "My spaces",
    "arrangedLikeKitchen": "Arranged like your kitchen",
    "fourSpacesHint": "Four spaces · add where you want",
    "dragHint": "Drag an item between spaces · hover to manage",
    "zones": {
      "fridge": "Fridge",
      "freezer": "Freezer",
      "counter": "Counter",
      "pantry": "Pantry"
    },
    "zoneCond": {
      "fridge": "3°C",
      "freezer": "−18°C",
      "counter": "room temp",
      "pantry": "dry"
    },
    "zoneUpToDate": "up to date",
    "zoneEmpty": "This space is empty.\nPhoto it or add by hand.",
    "zoneEmptyDesktop": "Empty — photo it or add items.",
    "freshness": {
      "urgent": "Use it up",
      "soon": "This week",
      "fresh": "Fresh",
      "stable": "long-keeping",
      "review": "to confirm",
      "expiredYesterday": "expired yesterday",
      "expiredDays": "expired · {{count}} d",
      "today": "today",
      "tomorrow": "tomorrow",
      "days": "~{{count}} days",
      "oneWeek": "~1 week",
      "twoWeeks": "~2 weeks",
      "threeWeeks": "~3 weeks",
      "oneMonth": "~1 month",
      "twoMonths": "~2 months",
      "threeMonths": "~3 months",
      "sixMonths": "~6 months",
      "aYear": "~1 year"
    },
    "cats": {
      "protein": "Protein",
      "vegetable": "Vegetable",
      "fruit": "Fruit",
      "dairy": "Dairy",
      "bread": "Bread",
      "condiment": "Condiment",
      "spice": "Spice",
      "staple": "Staple",
      "beverage": "Beverage",
      "leftover": "Leftover"
    },
    "cook": {
      "stripTitle_one": "{{count}} to use this week",
      "stripTitle_other": "{{count}} to use this week",
      "stripEmpty": "nothing for now",
      "stripCta": "Cook",
      "screenTitle": "Use it up",
      "screenSub": "Proteins, vegetables, and breads first",
      "cookThis": "Cook this",
      "eaten": "Eaten",
      "nothingUrgent": "Nothing urgent this week",
      "nothingUrgentSub": "All your fresh items have time.",
      "recipesTitle": "Recipes with {{name}}",
      "recipesSub": "Recipes that use it · plan one to use it up",
      "haveIngredients": "you have {{have}}/{{total}} ingredients",
      "addToMeal": "Add to a meal"
    },
    "item": {
      "stillGood": "Still good",
      "plusThreeDays": "+3 days",
      "eatenDone": "Eaten / finished",
      "tossed": "Tossed",
      "update": "Update",
      "move": "Move",
      "moveTitle": "Move \"{{name}}\"",
      "moveSub": "Currently in {{zone}} · tap the new space.",
      "currentlyHere": "here now",
      "opened": "Opened",
      "openedHint": "Shortens the estimate",
      "markedOpened": "Marked opened",
      "markedSealed": "Marked sealed",
      "freshnessUpdated": "Freshness updated",
      "freshnessExtended": "Freshness extended · +3 days",
      "movedTo": "{{name}} moved to {{zone}}",
      "eatenToast": "{{name}} · eaten",
      "tossedToast": "{{name}} · tossed",
      "removedToast": "{{name}} · removed",
      "undo": "Undo",
      "fallbackTitle": "Item"
    },
    "add": {
      "whereTitle": "Add where?",
      "toZone": "Add to {{zone}}",
      "addPanelSub": "Photo the space, search, or pick from recents",
      "photoSpace": "Photo the space",
      "photoAuto": "Auto food detection",
      "photo": "Photo",
      "photograph": "Photograph",
      "addManual": "Add",
      "searchPlaceholder": "Search for a food…",
      "recents": "Recents",
      "receipt": "Scan a receipt",
      "receiptLong": "Scan a grocery receipt",
      "receiptAuto": "Auto-sorted into the right spaces",
      "addedToZone": "{{name}} added to {{zone}}",
      "addedCount_one": "{{count}} item added",
      "addedCount_other": "{{count}} items added",
      "addedCountZone_one": "{{count}} item added to {{zone}}",
      "addedCountZone_other": "{{count}} items added to {{zone}}",
      "addedWithDups": "{{added}} added · {{dups}} already here",
      "alreadyPresent": "already here · quantity updated",
      "alreadyInCapture": "same food, already in this photo"
    },
    "capture": {
      "receiptTitle": "Grocery receipt",
      "aimHintReceipt": "Frame your grocery receipt and take the photo",
      "aimHintZone": "Frame your {{zone}} and take the photo",
      "analyzing": "Analyzing…",
      "analyzingSub": "Du Chef is identifying foods",
      "detected_one": "{{count}} item detected",
      "detected_other": "{{count}} items detected",
      "reviewSubReceipt": "Auto-sorted · tap a space to correct it",
      "reviewSubZone": "For your {{zone}} · uncheck as needed",
      "cancel": "Cancel",
      "confirm_one": "Add {{count}} item",
      "confirm_other": "Add {{count}} items",
      "whereTitle": "Where it goes",
      "changeZone": "Storage space: {{zone}}. Tap to change."
    },
    "empty": {
      "heroTitle": "Let's build your pantry",
      "heroSub": "Fastest: scan a grocery receipt or photo a space. Du Chef sorts and tracks freshness for you.",
      "receiptCta": "Scan a grocery receipt",
      "receiptCtaSub": "Whole grocery trip in one photo",
      "orPhotograph": "Or photo a space",
      "preview": "What expires first, at the top",
      "previewSub": "· tracked for you, no dates to type",
      "manual": "Add by hand",
      "seed": "Load sample",
      "seedDesktop": "Load a sample to explore",
      "demoBanner": "Demo sample.",
      "demoBannerSub": "Here's what a stocked pantry looks like.",
      "demoRemove": "Remove sample",
      "receiptCtaSubGuest": "With a free account · the whole grocery trip in one photo",
      "orPhotographGuest": "Or photo a space · with an account"
    },
    "review": {
      "entry": "Flash review",
      "entrySub_one": "{{count}} item to confirm",
      "entrySub_other": "{{count}} items to confirm",
      "entryCta": "Review",
      "panelSub": "{{current}} / {{total}} · ~20 s to stay current",
      "stillThere": "Still there?",
      "stillGoodQ": "Still good?",
      "expiredNote": "Expired recently — some foods keep a few days longer.",
      "addedAgo_one": "Added {{count}} day ago and never confirmed.",
      "addedAgo_other": "Added {{count}} days ago and never confirmed.",
      "yesStillThere": "Yes, still there",
      "yesPlusDays": "Yes, +5 days",
      "doneTossed": "Done / tossed",
      "allDone": "Pantry is current"
    },
    "plan": {
      "title": "Add to a meal",
      "sub": "\"{{recipe}}\" · tap a slot this week.",
      "replaceHint": "An occupied slot will be replaced · undoable.",
      "placed": "\"{{recipe}}\" scheduled · {{day}} · {{meal}}",
      "replaced": "\"{{recipe}}\" → {{day}} · {{meal}} (replaces {{prev}})"
    },
    "tidy": {
      "entry": "Tidy up",
      "entrySub_one": "{{count}} thing to settle",
      "entrySub_other": "{{count}} things to settle",
      "entryCta": "Open",
      "title": "Tidy the pantry",
      "panelSub_one": "{{count}} thing to settle",
      "panelSub_other": "{{count}} things to settle",
      "certainTitle": "Duplicates",
      "certainIntro": "These are the same food under different names. Uncheck any that are genuinely separate.",
      "maybeTitle": "Possible duplicates",
      "maybeIntro": "These look alike, but we are not sure. Your answer is remembered — the question will not come back.",
      "sortTitle": "To sort",
      "sortIntro": "We could not tell where these belong. Pick a spot, and it will hold for next time.",
      "same": "Same",
      "different": "Different",
      "absorbs": "merges: {{names}}",
      "expiryNote": "The merged row keeps the nearest expiry date, so nothing ends up looking fresher than it is.",
      "cancel": "Cancel",
      "confirm_one": "Apply {{count}} choice",
      "confirm_other": "Apply {{count}} choices",
      "none": "Nothing to tidy.",
      "done_one": "{{count}} row settled",
      "done_other": "{{count}} rows settled"
    },
    "clear": {
      "row_one": "Clear pantry · {{count}} item",
      "row_other": "Clear pantry · {{count}} items",
      "button_one": "Clear pantry ({{count}} item)",
      "button_other": "Clear pantry ({{count}} items)",
      "explainer": "Removes every item from your pantry, on this device and on every other one. What you have already eaten or thrown out is kept.",
      "busy": "Clearing…",
      "confirmTitle": "Clear your pantry?",
      "confirmBody_one": "{{count}} item will be removed everywhere, and this cannot be undone. Your eaten and thrown-out history is kept.",
      "confirmBody_other": "{{count}} items will be removed everywhere, and this cannot be undone. Your eaten and thrown-out history is kept.",
      "confirmAction": "Clear pantry",
      "done": "Your pantry is empty.",
      "localOnly": "Cleared on this device. The server could not be reached, so it may come back when you next open the app — try again once you are online."
    }
  },
  "weekly": {
    "counterItemsToBuyForMeals_one": "{{items}} to buy for {{count}} meal",
    "counterItemsToBuyForMeals_other": "{{items}} to buy for {{count}} meals",
    "counterAllCovered": "Everything is in your pantry",
    "counterSubAllCovered": "for this meal · nothing to buy",
    "counterSubAllCovered_other": "for your {{count}} meals · nothing to buy",
    "shopThisWeek": "Shop for this week",
    "shopThisWeekSub_one": "{{count}} meal planned",
    "shopThisWeekSub_other": "{{count}} meals planned",
    "addBreakfast": "Add breakfast",
    "addLunch": "Add lunch",
    "addDinner": "Add dinner"
  },
  "editRecipe": {
    "saved": "Recipe saved.",
    "saveFailed": "Failed to save recipe. Please try again.",
    "closeMenu": "Close menu",
    "deleteFailed": "Failed to delete recipe",
    "handsOnLabel": "Hands-on (min)",
    "readyInLabel": "Ready in (min)",
    "timeHandsOnExceedsReady": "Hands-on can't be longer than the total",
    "timeNotANumber": "Enter a number of minutes"
  },
  "editItem": {
    "title": "Edit Item",
    "subtitle": "Modify the details of your food item",
    "itemName": "Item Name",
    "category": "Category",
    "quantity": "Quantity",
    "expiryDate": "Expiry Date",
    "clearExpiryHint": "Leave empty to remove expiry date",
    "saveChanges": "Save Changes"
  },
  "planRecipe": {
    "title": "Plan for This Week",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "thisWeekend": "This Weekend",
    "orPickADay": "Or Pick a Day"
  },
  "importReview": {
    "title": "Review",
    "adminOnly": "This screen is for administrators only.",
    "loadFailed": "Could not load the recipes to review.",
    "publishFailed": "Publishing failed.",
    "publishSelected": "Publish {{count}} recipe",
    "publishSelected_other": "Publish {{count}} recipes",
    "publishSuccess": "{{count}} recipe published to the shared library",
    "publishSuccess_other": "{{count}} recipes published to the shared library",
    "publishPartial": "{{published}} published, {{skipped}} skipped",
    "subtitle": "What we publish should be right. Every tag you settle here also teaches the AI.",
    "entry": "Review",
    "entryCount": "Review · {{count}}",
    "filters": {
      "to-check": "To check",
      "looks-right": "Look right",
      "ready-to-publish": "Ready to publish",
      "done": "Done"
    },
    "sources": {
      "all": "All sources",
      "import": "New imports",
      "library": "My library",
      "catalogue": "Catalogue"
    },
    "sourceLabel": {
      "import": "New import",
      "library": "My library",
      "catalogue": "Catalogue"
    },
    "legend": {
      "confirmed": "you confirmed",
      "sure": "AI is sure",
      "unsure": "AI unsure: tap to check",
      "missing": "missing",
      "auto": "accepted before, never looked at"
    },
    "toCheck_one": "{{count}} to check",
    "toCheck_other": "{{count}} to check",
    "blockedAccept": "Missing steps or ingredients",
    "acceptHint": "Then ready to publish",
    "glance_one": "This {{count}} looks right",
    "glance_other": "These {{count}} look right",
    "glanceHint": "Check the photos and tags on screen, then confirm them in one tap.",
    "glanceDone_one": "{{count}} recipe confirmed",
    "glanceDone_other": "{{count}} recipes confirmed",
    "glanceSkipped_one": "{{count}} changed since it was loaded and stays to check",
    "glanceSkipped_other": "{{count}} changed since they were loaded and stay to check",
    "loadMore": "Show more",
    "emptyFilter": {
      "to-check": "Nothing to check.",
      "looks-right": "Nothing waiting for a glance.",
      "ready-to-publish": "Nothing ready to publish.",
      "done": "Nothing settled yet."
    },
    "gaps": {
      "ingredients": "No ingredients",
      "steps": "No steps",
      "image": "No photo"
    },
    "addPhoto": "Add photo",
    "photoFailed": "The photo could not be uploaded.",
    "refetch": "Re-fetch",
    "refetchFound": "Found on the page: {{fields}}",
    "refetchNothing": "Nothing new on the page",
    "refetchUnreadable": "The page could not be read",
    "refetchNoSource": "No source page to read",
    "aiGuess": "AI's guess",
    "auto": "auto",
    "edit": "Edit",
    "reject": "Reject",
    "loop": {
      "title": "The AI, judged by your reviews",
      "meta": "prompt {{version}} · last {{days}} days",
      "field": "{{field}} {{percent}}%",
      "glance": "glance {{percent}}%",
      "noAnswers": "no answers yet",
      "mostCorrected": "Most corrected: {{field}} {{from}} → {{to}} ({{count}})",
      "timeError": "typical miss {{minutes}} min"
    }
  },
  "entryForm": {
    "diningTitle": "Eating out or delivery",
    "noteTitle": "Simple meal",
    "whereLabel": "Where?",
    "noteLabel": "Note (optional)",
    "eatingLabel": "What are you eating?",
    "placePlaceholder": "e.g. Pizza at Nino’s",
    "notePlaceholder": "e.g. 7 p.m. reservation",
    "textPlaceholder": "e.g. Tuna sandwich",
    "defaultPlace": "Eating out",
    "diningPresets": [
      "Restaurant",
      "Delivery",
      "Night out",
      "At family’s",
      "Brunch"
    ],
    "notePresets": [
      "Tuna sandwich",
      "Omelette",
      "Buttered pasta",
      "Grilled cheese",
      "Soup and bread",
      "From the freezer"
    ]
  },
  "mealConfig": {
    "weekSettings": "Week settings",
    "weekSettingsShort": "Week settings",
    "appliesByDefault": "Applied by default to every meal.",
    "defaultPortions": "Default servings",
    "targetMix": "Target mix",
    "softGuide": "A soft guide — the planner aims for it.",
    "fish": "Fish",
    "veggie": "Veggie",
    "meat": "Meat",
    "quickSelect": "Quick select:",
    "allDinners": "All dinners",
    "allLunches": "All lunches",
    "wholeWeek": "Whole week",
    "dinners": "Dinners",
    "lunches": "Lunches",
    "clear": "Clear",
    "weekDefault": "Week default",
    "mealType": "Meal type",
    "removeThisMeal": "Remove this meal",
    "dontSuggestHere": "Don't suggest here",
    "planMyWeek": "Plan my week",
    "planShort": "Plan",
    "yourSuggestions": "Your suggestions",
    "configHint": "Tap the meals to plan, then set servings and type for each cell.",
    "generatingHint": "Your week is filling in — you can adjust everything afterwards.",
    "generating": "Generating…",
    "loadingRecipes": "Loading recipes…",
    "tapToChoose": "Tap cells to choose which meals to suggest",
    "selectMeals": "Select some meals",
    "mealSelected": "{{count}} meal selected",
    "mealSelected_other": "{{count}} meals selected",
    "generateSuggestion": "Generate {{count}} suggestion",
    "generateSuggestion_other": "Generate {{count}} suggestions",
    "anotherRecipe": "Another recipe",
    "auto": "Auto",
    "affinity": {
      "title": "Putting together your suggestions for the week",
      "resembles": "feels like you",
      "keptFor": "kept for {{day}}",
      "reviewedLabel_one": "recipe looked at",
      "reviewedLabel_other": "recipes looked at",
      "finalists_one": "{{count}} finalist",
      "finalists_other": "{{count}} finalists",
      "kept_one": "{{count}} kept",
      "kept_other": "{{count}} kept",
      "preparing": "Preparing your week…",
      "ready_one": "Your week is ready · {{count}} meal",
      "ready_other": "Your week is ready · {{count}} meals",
      "factAvoid": "No {{item}}",
      "factPantry": "Fridge · {{items}}",
      "factTime": "{{day}} · {{minutes}} min",
      "factHistory": "Not on last week’s menu",
      "factDiet": "Week · {{kind}} ×{{count}}",
      "kindVeg": "veggie",
      "kindFish": "fish",
      "kindMeat": "meat"
    }
  },
  "cookLog": {
    "cancel": "Cancel",
    "captureSubtitle": "We'll add it to your history.",
    "captureTitle": "How was it?",
    "cookedOn": "COOKED ON",
    "noteLabel": "A NOTE FOR NEXT TIME",
    "notePlaceholder": "Double the vinaigrette next time…",
    "notesHeader": "Your notes",
    "optional": "optional",
    "save": "Save to log",
    "today": "Today",
    "yourRating": "YOUR RATING",
    "ratingLabels": [
      "",
      "Meh",
      "OK",
      "Good",
      "Very good",
      "Loved it"
    ],
    "cookedOnDismiss": "I marked it as cooked."
  },
  "entry": {
    "dining": "Eating out",
    "diningLong": "Eating out or delivery",
    "leftovers": "Leftovers",
    "note": "Simple meal",
    "nothing": "Nothing planned",
    "nothingShort": "Nothing",
    "nothingThatDay": "Nothing that day",
    "chooseRecipe": "Choose a recipe",
    "clearSlot": "Clear slot",
    "restaurantShort": "Restaurant",
    "currently": "CURRENTLY",
    "noteFree": "Simple meal",
    "subLibrary": "The library",
    "subEatingOut": "I'm eating out",
    "subRecentMeal": "From a recent meal",
    "subNoteHint": "Tuna sandwich, omelette…",
    "subNoPlan": "No meal planned",
    "replaceDish": "Replace this dish",
    "addMeal": "Add a meal",
    "view": "View",
    "ideasForYou": "IDEAS FOR YOU",
    "ideaForYou_one": "{{count}} IDEA FOR YOU",
    "ideaForYou_other": "{{count}} IDEAS FOR YOU",
    "noOtherRecipes": "No other recipes in your library. Add some to get ideas.",
    "editMeal": "Edit this meal",
    "leftoverTitle": "Leftovers — {{title}}",
    "recentMeal": "a recent meal",
    "editSlotCaption": "EDIT THIS SLOT",
    "addToSlotCaption": "ADD TO THIS SLOT",
    "leftoversHint": "What's left in the fridge",
    "skipHint": "We skip this meal"
  },
  "cooking": {
    "timer": "TIMER",
    "theSteps": "THE STEPS",
    "previous": "Previous",
    "noSteps": "No steps available for this recipe.",
    "enjoy": "Enjoy your meal!",
    "likedRecipe": "Did you like this recipe?",
    "skipForNow": "Skip for now",
    "startCooking": "Start cooking",
    "cookingStart": "COOKING STARTS",
    "timeline": "TIMELINE",
    "atTable": "At the table",
    "atTableAt": "At the table at",
    "stepNumber": "STEP {{number}}",
    "nextStep": "Next step",
    "ready": "Ready!",
    "timerDone": "Done",
    "timerStart": "Start",
    "timerPause": "Pause",
    "timelineStartPrep": "Start prep",
    "timelineStartCooking": "Start cooking",
    "timelineStart": "Start",
    "timelineReady": "Ready",
    "quit": "Quit"
  },
  "classify": {
    "main course": "Meal",
    "dessert": "Dessert",
    "breakfast": "Breakfast",
    "beverage": "Drink",
    "sauce": "Sauce",
    "snack": "Snack",
    "appetizer": "Starter",
    "salad": "Salad",
    "soup": "Soup",
    "side dish": "Side"
  },
  "photoImport": {
    "readingRecipe": "Reading your recipe…",
    "addAnotherPage": "Add another page",
    "couldNotRead": "Couldn't read this clearly",
    "chooseAnother": "Choose another",
    "saveToPaprika": "Save to Du Chef",
    "pasteLufa": "Paste your Lufa order email here…",
    "parsingOrder": "Parsing your order…",
    "unknownParseError": "Unknown parsing error",
    "voiceHint": "Tap the mic on your keyboard for voice input",
    "lufaTitle": "Import a Lufa delivery",
    "lufaInstruction": "Paste your Lufa order confirmation email below",
    "parseOrder": "Read the order",
    "itemsSelected_one": "{{count}} item selected",
    "itemsSelected_other": "{{count}} items selected",
    "deliveryDate": "Delivery: {{date}}",
    "addItemsToPantry_one": "Add {{count}} item to the pantry",
    "addItemsToPantry_other": "Add {{count}} items to the pantry",
    "frozen": "Frozen",
    "blurry": "The photo was too blurry or didn't contain a readable recipe. Try a clearer shot.",
    "retakePhoto": "Retake photo",
    "confidence": "Confidence",
    "incompleteWarning": "Some fields may be incomplete — review before saving.",
    "titleLabel": "Title",
    "prepMinutes": "Prep {{minutes}} min",
    "cookMinutes": "Cook {{minutes}} min",
    "servings_one": "{{count}} serving",
    "servings_other": "{{count}} servings",
    "ingredientsCount": "Ingredients ({{count}})",
    "instructionsCount": "Instructions ({{count}})",
    "editBeforeSaving": "Edit before saving",
    "importRecipe": "Import a recipe",
    "reviewRecipe": "Review the recipe",
    "pageNumber": "Page {{number}}",
    "addMorePagesHint": "Add more pages if your recipe spans multiple photos.",
    "pagesReady": "{{count}} pages ready to scan.",
    "scanRecipe": "Scan recipe",
    "scanPages": "Scan {{count}} pages",
    "preparingPhoto": "Preparing the photo…",
    "analyzingPhoto": "Analyzing…",
    "sourceName": "Photo",
    "lufaReadFailed": "I could not read that order. Check that the whole email is there, then try again."
  },
  "matchReason": {
    "taste": "Matches your taste profile",
    "novelty": "New recipe to try!"
  },
  "household": {
    "errAlreadyPaired": "You're already sharing with someone. Leave that household first.",
    "rowSoloTitle": "Share with your partner",
    "rowSoloSubtitle": "Plan, shop, and cook together",
    "rowPendingTitle": "Invitation pending",
    "rowPendingSubtitle": "Code {{code}} · expires in {{hours}} h",
    "rowPendingSubtitleSoon": "Code {{code}} · expires soon",
    "rowPairedTitle": "Shared with {{name}}",
    "headerTitle": "Household",
    "soloHeadline": "Plan, shop, and cook together.",
    "soloBody": "Invite one person. Everything below becomes shared between the two of you.",
    "sharesPlan": "The weekly meal plan",
    "sharesGrocery": "The grocery list",
    "sharesRecipes": "Saved recipes and ratings",
    "sharesPantry": "The pantry",
    "createInvitation": "Create an invitation",
    "creating": "Creating your invitation…",
    "pendingHeadline": "Waiting for your partner",
    "pendingBody": "Send them this code, or the link. It works once.",
    "codeLabel": "YOUR INVITATION CODE",
    "expiresIn": "Expires in {{hours}} hours",
    "expiresSoon": "Expires within the hour",
    "shareLink": "Share the link",
    "copyCode": "Copy the code",
    "copied": "Copied",
    "cancelInvitation": "Cancel this invitation",
    "cancelling": "Cancelling…",
    "shareMessage": "Join my Du Chef household — we'll share recipes, the meal plan, and the grocery list.\n\n{{link}}\n\nOr enter the code: {{code}}",
    "pairedHeadline": "Your household",
    "pairedBody": "Two people. Everything below is shared.",
    "you": "You",
    "memberSince": "Joined {{date}}",
    "leaveHousehold": "Leave this household",
    "removePartner": "Remove {{name}}",
    "leaveTitle": "Leave this household?",
    "leaveBody": "You both keep a full copy. Nothing is deleted.",
    "removeTitle": "Remove {{name}}?",
    "removeBody": "They keep a full copy. Nothing is deleted.",
    "keepsHead": "You keep",
    "keepsHeadThem": "They keep",
    "keepRecipes": "Saved recipes",
    "keepRatings": "Ratings",
    "keepPantry": "Pantry items",
    "keepWeeks": "Meal-plan weeks",
    "leaveConfirm": "Leave",
    "removeConfirm": "Remove",
    "stay": "Stay",
    "leavingTitle": "Moving your things",
    "leavingBody": "Copying everything back to your account. Keep the app open.",
    "leaving": "Leaving…",
    "removingTitle": "Moving their things",
    "removingBody": "Copying everything to their account. Keep the app open.",
    "removing": "Removing…",
    "leftTitle": "You’ve left.",
    "leftBody": "{{recipes}} recipes, {{ratings}} ratings and {{pantry}} pantry items are in your account.",
    "removedTitle": "{{name}} has been removed.",
    "removedBody": "They keep a full copy. The household is yours alone now.",
    "leftUnverifiedTitle": "You’ve left, but nothing loaded here.",
    "leftUnverifiedBody": "Your data is safe. Reload to see it.",
    "reload": "Reload",
    "errLeave": "Could not leave the household. Please try again.",
    "nameTitle": "What should we call you?",
    "nameBody": "Your partner will see this name instead of your email address.",
    "namePlaceholder": "First name",
    "nameSave": "Continue",
    "nameSkip": "Skip for now",
    "errSignedOut": "You need to be signed in to share with a partner.",
    "errGeneric": "Could not create the invitation. Please try again.",
    "errMoveFailed": "Your recipes and pantry could not be moved into the household. Nothing has changed. Please try again.",
    "errNetwork": "No connection. Check your network and try again.",
    "errSessionExpired": "You have been signed out. Sign in again, then try once more.",
    "errSessionChanged": "Your account changed in another tab. Reload the page and try again.",
    "errFull": "Your household already has two members.",
    "errNotInHousehold": "You are no longer in this household. Reload the page.",
    "errRevoke": "Could not cancel the invitation. Please try again.",
    "tryAgain": "Try again",
    "approval": {
      "agree": "Works for me",
      "refuse": "Not that one",
      "agreedBoth": "You both agree",
      "self": "you",
      "cooks": "{{name}} is cooking",
      "cooksYou": "you're cooking",
      "claim": "I'll take it",
      "propose": "Propose",
      "proposedBy": "Proposed · {{name}}",
      "putOnMenu": "Put on the menu",
      "noneOnMenu": "Nothing on the menu",
      "toSettle": "{{count}} proposal to settle",
      "toSettle_other": "{{count}} proposals to settle"
    },
    "eaters": {
      "sectionTitle": "WHO EATS HERE",
      "addSomeone": "Add someone",
      "account": "account",
      "accountsElsewhere": "Accounts are edited in settings.",
      "selfLabel": "You",
      "firstName": "First name",
      "namePlaceholder": "Jules",
      "addTitle": "Add someone",
      "add": "Add",
      "cancel": "Cancel",
      "save": "Save",
      "remove": "Remove from household",
      "removeNote": "Their past verdicts are kept.",
      "empty": "Add the other people who eat at home."
    },
    "verdict": {
      "title_one": "There was {{count}} of you at the table",
      "title_other": "There were {{count}} of you at the table",
      "question": "{{title}} — who liked it?",
      "love": "Loved it",
      "ok": "It was fine",
      "no": "Nope",
      "later": "Later",
      "addPeople": "Add the others",
      "soloHint": "Add the other people at your table to collect their verdicts.",
      "done": "Done",
      "sectionLabel": "WHO LIKED IT?",
      "whoLiked": "Who liked it?",
      "overflow": "+{{count}}",
      "unanswered": "no answer"
    }
  },
  "scanGate": {
    "title": "Create an account to scan",
    "body": "To read a photo of a fridge, a receipt or a recipe, Du Chef needs an account: that's where your pantry and recipes are kept. It's free, and your meal plan comes with you.",
    "cta": "Create a free account",
    "signIn": "I already have an account",
    "later": "Not now",
    "lockedHint": "With an account",
    "signedOut": "You've been signed out. Sign in again to scan.",
    "signInAgain": "Sign in again"
  },
  "recipeMetadata": {
    "cuisine": "Cuisine",
    "dishType": "Type",
    "diet": "Diet",
    "accept": "Accept",
    "choose": "Choose",
    "suggesting": "Suggesting…",
    "suggestFailed": "Suggestions failed. Try again.",
    "reviewFailed": "Could not save the tags. Try again.",
    "source": {
      "publisher": "from the page",
      "rules": "rule",
      "model": "AI"
    },
    "cuisines": {
      "quebecois": "Québécois",
      "french": "French",
      "italian": "Italian",
      "spanish": "Spanish",
      "greek": "Greek",
      "middle-eastern": "Middle Eastern",
      "north-african": "North African",
      "indian": "Indian",
      "chinese": "Chinese",
      "japanese": "Japanese",
      "korean": "Korean",
      "thai": "Thai",
      "vietnamese": "Vietnamese",
      "mexican": "Mexican",
      "latin-american": "Latin American",
      "caribbean": "Caribbean",
      "american": "American",
      "eastern-european": "Eastern European",
      "everyday": "Everyday"
    },
    "diets": {
      "meat": "Meat",
      "fish": "Fish",
      "veg": "Vegetarian"
    },
    "checks": {
      "image_mismatch": "Photo looks like another dish",
      "image_missing": "No photo",
      "unused_ingredients": "Not used in any step: {{items}}",
      "missing_ingredients": "Steps call for: {{items}}",
      "prep_exceeds_total": "Prep is longer than the total time",
      "parts_exceed_total": "Prep + cook exceed the total time",
      "total_default": "Total time looks like a 30 min default",
      "total_missing": "No total time",
      "timeline_disputed": "The estimated time doesn't match the page",
      "timeline_person": "Time entered by hand: {{ready}}",
      "timelineDisputedEstimate": "Estimate: {{handsOn}} hands-on, ready in {{ready}}"
    },
    "time": "Time",
    "timeTotal": "{{total}} min",
    "timeParts": "{{prep}} + {{cook}} min",
    "timePartsTotal": "{{prep}} + {{cook}} · {{total}} min",
    "timePrepTotal": "{{prep}} · {{total}} min",
    "timeHandsOn": "Hands-on (you, min)",
    "timeCook": "Cook (min)",
    "timeReady": "Ready in (min)",
    "timeTotalHint": "blank = Hands-on + Cook",
    "timeSave": "Save time",
    "timeInvalid": "Enter whole minutes. \"Ready in\" can't be shorter than the hands-on or cook time.",
    "timeFromPage": "From the page: {{value}}",
    "timeAiGuess": "AI's guess: {{value}}"
  },
  "errorBoundary": {
    "message": "The app ran into an unexpected problem. You can try again or go back to the home screen.",
    "retry": "Try again",
    "goHome": "Go home"
  },
  "syncStatus": {
    "updating": "Updating…",
    "upToDate": "Up to date",
    "updatedAgo": "Updated {{ago}}",
    "justNow": "just now",
    "minutesAgo": "{{count}} min ago",
    "hoursAgo": "{{count}} h ago",
    "daysAgo_one": "{{count}} day ago",
    "daysAgo_other": "{{count}} days ago"
  },
  "skipFeedback": {
    "titleRemove": "Why skip this?",
    "titleReplace": "Why replace this?",
    "placeholderRemove": "e.g. “Too heavy for a weeknight”",
    "placeholderReplace": "e.g. “Something quicker please”",
    "skip": "Skip without feedback",
    "submit": "Send feedback",
    "typeSomething": "Type something above"
  },
  "ingredientReview": {
    "checkHave": "Check the ingredients you already have",
    "uncheckedToList": "Unchecked items will be added to your grocery list",
    "foundInInventory_one": "{{count}} item found in your inventory",
    "foundInInventory_other": "{{count}} items found in your inventory",
    "confirmMatches_one": "Confirm {{count}} inventory match",
    "confirmMatches_other": "Confirm {{count}} inventory matches",
    "inInventory": "In inventory",
    "plusList": "+ list",
    "haveCount": "{{count}} have",
    "needCount": "{{count}} need",
    "markReviewed": "Mark as reviewed"
  },
  "pantryMatch": {
    "all": "All {{count}} ingredients are in your pantry!",
    "none": "None of the {{count}} ingredients are in your pantry",
    "covers": "Your pantry covers {{matched}} of {{total}} ingredients",
    "more": "+{{count}} more",
    "needToBuy": "Need to buy: {{count}} more"
  },
  "smartInventory": {
    "title": "Smart Inventory",
    "curating": "Curating your\ninventory…",
    "devMode": "DEV MODE",
    "hintFridge": "Align items within the frame for best results",
    "hintReceipt": "Center the receipt in the frame",
    "noImage": "No image provided",
    "percentComplete": "{{percent}}% COMPLETE",
    "oldReceipt_one": "Old receipt from {{date}} ({{count}} day ago) — expiry estimates may be inaccurate",
    "oldReceipt_other": "Old receipt from {{date}} ({{count}} days ago) — expiry estimates may be inaccurate",
    "scanningPantry": "SCANNING PANTRY ITEMS",
    "scanningReceipt": "SCANNING RECEIPT"
  }
}
